const cn = {
  "401": {
    "goback": "poprzednia strona",
    "gohome": "strona główna",
    "oops": "Szkoda!",
    "noAuth": "Nie masz uprawnień do dostępu do tej strony"
  },
  "intro": {
    "step_operate_1": "Jasniejszy układ informacji o urządzeniu",
    "step_operate_2": "Po wybraniu urządzenia, które chcesz wiedzieć, możesz szybko przeglądać wykres przepływu energii, informacje o urządzeniu, wykresy danych, analizę parametrów, szczegóły danych i informacje alarmowe urządzenia.",
    "step_device_10": "Wygodnie jest dla Ciebie znaleźć urządzenia, na których Ci zależy.",
    "step_project_5": "Nowy, Edytuj, Usuń",
    "step_project_4": "Zarządzanie funkcjami i urządzeniami według projektu. Użytkownicy mogą dokonywać dostosowań do projektu",
    "slider_quite": "Wskazówki dotyczące wyjścia",
    "step_project_3": "zarządzanie projektami",
    "step_project_2": "nowo dodane",
    "step_project_1": "Sprzęt do zarządzania nowym systemem",
    "step_device_6": "Gdy jesteś na urządzeniu, możesz kliknąć Follow,",
    "step_device_7": "Po następującym",
    "step_device_8": "Sprzęt może być wykorzystywany w tym projekcie jako",
    "slider_next": "następny krok",
    "step_device_9": "Doładować",
    "new_guide": "Przewodnik dla początkujących",
    "gaa_msg": "Przypomnienie alarmu",
    "step_device_1": "Szybko znajdź interesujące urządzenie",
    "step_device_2": "nowo dodane",
    "step_device_3": "Śledź urządzenia",
    "slider_enter": "Wprowadź nową wersję",
    "step_device_4": "Funkcja,",
    "step_device_5": "Nacisk myszy",
    "sys_msg": "Komunikat systemowy",
    "step_mode_3": "Lista lub karta",
    "step_mode_4": "Prezentując w formie, możesz wybrać metodę prezentacji zgodnie z Twoją sytuacją.",
    "step_mode_1": "Wybierz swój ulubiony styl listy urządzeń",
    "step_mode_2": "Do listy urządzeń można uzyskać dostęp poprzez",
    "slider_pre": "Poprzedni krok"
  },
  "404": {
    "notFound": "Strona nie może zostać znaleziona"
  },
  "plantCode": {
    "successfulApplication": "Aplikacja pomyślna, postępuj zgodnie z informacjami telefonicznymi lub e-mailowymi, odpowiemy tak szybko, jak to możliwe",
    "goRegister": "Przejdź do rejestracji",
    "haveDevice": "Jeśli masz już urządzenie, możesz się zarejestrować i zalogować, aby z niego korzystać",
    "code_is_required": "Kod doświadczenia nie może być pusty",
    "useDemo": "Nie masz jeszcze kodu zaproszenia? Kod zaproszenia jest używany tylko do demonstracji funkcjonalnej",
    "pleaseName": "Proszę wprowadzić swoje imię i nazwisko",
    "PleaseNumber": "Proszę wprowadzić swój numer telefonu kontaktowego",
    "codeApplication": "Wniosek o kodeks doświadczenia",
    "pleaseCode": "Proszę wprowadź kod zaproszenia",
    "PleaseEmail": "Proszę wpisać swój adres e-mail",
    "PleaseCompanyName": "Proszę wprowadzić nazwę firmy",
    "reasonNotEmpty": "Powód wniosku nie może być pusty",
    "applyNow": "Zgłoś się teraz",
    "PleaseApplication": "Proszę opisać powody wniosku",
    "PleaseCompanyAddress": "Proszę wprowadzić adres firmy"
  },
  "retrieveUser": {
    "accountInfo": "Informacje o koncie",
    "pleasePn": "Proszę wpisać PN urządzenia",
    "forgetUser": "Zapomniałem konta",
    "phone": "Jaki jest numer telefonu powiązany z Twoim kontem?",
    "Return_to_login": "Powrót do logowania",
    "illustrate": "Jeśli zapomnisz swojego konta, możesz uzyskać pytania o informacje o koncie, wpisując numer PN dowolnego urządzenia pod swoim konciem, aby pomóc Ci odzyskać konto!",
    "pnError": "Wprowadzony przez Ciebie numer PN jest nieprawidłowy",
    "comfig": "Ok",
    "pnErrorMsg": "Nie znaleziono urządzenia do pozyskiwania danych",
    "user": "Twoja nazwa użytkownika to",
    "email": "Jaki jest adres e-mail powiązany z Twoim kontem",
    "pn": "Proszę wpisać PN dowolnego urządzenia na swoim koncie"
  },
  "version": {
    "to_new": "Powrót do nowej wersji",
    "to_old": "Powrót do starej wersji",
    "custom_theme": "Dostosowany motyw",
    "default_theme": "Domyślny motyw",
    "default_node": "Domyślny węzeł"
  },
  "createPlant": {
    "fileExceed": "Plik jest zbyt duży",
    "Control_settings": "Ustawienia maszyny do magazynowania energii",
    "basic_settings": "Ustawienia podstawowe",
    "Basic_setting": "Ustawienia podstawowe",
    "select_all": "Zaznacz wszystkie",
    "pv": "PV",
    "gd": "Sieć",
    "bt": "Bateria",
    "bc": "Obciążenie",
    "sy": "System",
    "eg": "Generator",
    "hl": "ObciążenieDomowe",
    "System_settings": "Ustawienia systemowe",
    "Grid_settings": "Konfiguracja sieci energetycznej",
    "Solar_settings": "Ustawienia energii słonecznej",
    "imageLimit": "Obraz obsługuje tylko formaty JPG i PNG, z maksymalnym rozmiarem 8M",
    "Load_setting": "Ustawienie ładowania",
    "Standard_setting": "Ustawienia standardowe",
    "other_settings": "Inne ustawienia",
    "Advanced_setting": "zaawansowane ustawienia",
    "Battery_settings": "Ustawienia baterii",
    "Battery_settingsTT": "Ogólne ustawienia akumulatora",
    "Battery_settings1": "Zestaw akumulatorów 1",
		"Battery_settings2": "Zestaw akumulatorów 2",
    "Work_settings2": "Ustaw stan pracy systemu",
    "Machine_settings2": "Włącz funkcję gotowości maszyny",
    "Clear_settings2": "Usuń błąd",
    "uploadSuccess": "Przesyłanie pomyślne"
  },
  "Upload": {
    "Upload": "przesłać"
  },
  "login": {
    "code": "Przesuń suwak poniżej, aby ukończyć układankę",
    "forgotUser": "Zapomniałem konta",
    "scanning": "Skanuj",
    "loginSuc": "Zalogowanie pomyślne",
    "pv123": "PV123 ESS",
    "YZcode": "Wprowadź kod weryfikacyjny",
    "login": "Zaloguj się",
    "scan_download": "Zeskanuj kod QR w telefonie, aby pobrać aplikację",
    "YHLogin": "Zalogowanie użytkownika",
    "scan_login": "Skanuj kod do logowania",
    "usr": "Nazwa użytkownika",
    "SmartESS": "Guangchubao.",
    "forgotPwd": "Zapomniałeś hasła?",
    "app_download": "Pobieranie APPki",
    "invitationLogin": "Login kodu doświadczenia",
    "pwdformat": "Format hasła (6<=długość hasła<=32)",
    "usrformat": "Format konta (2<=długość użytkownika<=32)",
    "Pleaseconfirm_login": "Proszę potwierdź login",
    "remember_pwd": "Zapamiętaj hasło",
    "YZcode_format": "Błąd formatu kodu weryfikacyjnego, proszę wprowadzić numer",
    "invitation": "Kodeks doświadczenia",
    "no_invitation": "Nie masz jeszcze kodu doświadczenia? Prosimy o kontakt",
    "signup": "Zarejestruj natychmiast",
    "linkman": "Yibang Sunshine",
    "sample_station": "demonstracja",
    "X_Tech": "X-Tech",
    "success": "Powodzenie",
    "no_account_yet": "Nie masz jeszcze konta z Smartx ?",
    "Scancode_login": "Wyczyśc login",
    "pwd": "Hasło",
    "open": "otwarty",
    "Swipe_right": "Przesuń w prawo",
    "no_validitycode": "Kod zaproszenia nie jest ważny",
		"auto_login": "Automatyczne logowanie",
  },
  "signup": {
    "too_simple": "Hasło jest zbyt proste, proszę ponownie wprowadzić",
    "code": "6-cyfrowy kod weryfikacyjny",
    "qiangdu": "Siła hasła:",
    "di": "słaby",
    "registered": "zarejestruj się",
    "login": "Zaloguj się teraz",
    "confirm_Pwdpl": "Potwierdź hasło",
    "mobile_pl": "numer telefonu",
    "confirm_password": "Proszę wprowadzić hasło ponownie",
    "emailSignup": "Rejestracja e-mail",
    "PN_pl": "Numer cześci",
    "zhong": "w",
    "email_form": "Proszę dokładnie wypełnić hasło w 64-znakach w celu pobrania hasła",
    "usr": "Znaki 2-32 (chiński, litery, cyfry, tylko podkreślenie) Nazwa konta",
    "emailformat": "Proszę wprowadzić poprawny adres e-mail",
    "email": "Adres emial",
    "pwdformat": "Błąd formatu hasła, znaki 6-32 (dozwolone tylko liczby, litery, podkreślenia)",
    "usrformat": "Błąd formatowania konta, 2-32 (dozwolone są tylko chińskie, litery, cyfry i podkreślenia)",
    "email_pl": "Adres Email",
    "pwd_pl": "Hasło",
    "Byte_2": "znaków jest wymaganych",
    "pnformat": "Błąd formatowania numerów PN, 14 lub 18-cyfrowy (można użyć tylko cyfr i liter)",
    "Byte_1": "Wprowadzono",
    "phoneSignup": "Rejestracja mobilna",
    "mobileformat1": "Proszę wprowadzić poprawny numer telefonu",
    "mobileformat": "Błąd formatowania numeru telefonu (6-32)",
    "qiang": "silny",
    "code_pl": "Kod weryfikacji",
    "confirm_pl": "Proszę wprowadzić hasło ponownie",
    "signup": "zarejestruj się",
    "phone": "Telefon komórkowy",
    "success": "Rejstracja zakonczona sukcesem",
    "usr_pl": "Nazwa użytkownika",
    "phone_form": "Proszę dokładnie wypełnić hasło w 32-znakach w celu pobrania hasła",
    "Register_account": "Rejestracja rachunku",
    "existing_account": "Masz już konto?",
    "pwd": "6-32 znaków (cyfry, litery, podkreślenia), wielkość liter",
    "pn": "14 lub 18-znaków (można używać tylko cyfr i liter)",
    "country_pl": "Kraj lub region",
  },
  "statistic": {
    "All": "Wszystkie",
    "bc": "Wczytaj dane",
    "normal": "Zwykły",
    "other": "inne",
    "totalRegion": "Wszystkie regiony",
    "totalDevice": "Wszystkie urządzenia",
    "standby": "Tryb czuwania",
    "regiontotal": "Łączna liczba regionów",
    "sy": "Dane dotyczące wyposażenia",
    "pv": "Dane paneli fotowoltaicznych",
    "active": "aktywny",
    "allDevice": "Łączna liczba urządzeń",
    "fault": "Niepowodzenie",
    "generalAccount": "Użytkownik właściciela",
    "deviceStatus": "Stan urządzenia",
    "allAccount": "Wszyscy użytkownicy",
    "offline": "Offline",
    "regionPercent": "Proporcja regionalna",
    "bt": "Dane baterii",
    "inactive": "Nieaktywny",
    "Allstate": "Wszystkie stany",
    "adminAccount": "Użytkownicy dealerzy",
    "warning": "Ostrzeżenie",
    "userActivity": "Wskaźnik aktywności użytkownika",
    "dataUpdateTime": "Czas aktualizacji danych",
    "gd": "Dane siatki"
  },
  "role": {
    "all": "Wszystkie",
    "viewer": "Przeglądarka systemu PV",
    "plantOwnerNew": "Zwykli użytkownicy",
    "plantOwner": "Właściciel systemu PV",
    "distributor": "Dystrybutor",
    "group": "Rachunek grupy",
    "manufacturer": "Rachunek producenta"
  },
  "header": {
    "pnAndSN": "PN / SN",
    "plant_owner": "Właściciel systemu PV",
    "operating_manual": "Podręcznik obsługi",
    "bind_email": "Wiąż e-mail",
    "bind_mobile": "Wiąż telefon",
    "skin": "Przełączanie skóry",
    "language": "Ustawienia języka",
    "pleaseSelect1": "Proszę wybrać godzinę",
    "log_out": "Wyjdź z systemu",
    "change_password": "Modyfikuj hasło",
    "shopping_mall": "Centrum handlowe",
    "pnAndAlias": "Numer PN/nazwa urządzenia do pozyskiwania danych",
    "personal_infor": "Dane osobowe",
    "pleaseSelect": "Proszę wybrać"
  },
  "menu": {
    "datalogger": "Zarządzanie datalogerami",
    "Total_user": "Łączna liczba użytkowników:",
    "protocol_binding": "Wiążący protokół pozyskiwania danych",
    "log": "Dziennik rejestratora danych",
    "Recharge_remedy": "Środek zaradczy",
    "customize": "Ustawienia niestandardowe",
    "AIP_Interface": "Interfejs API",
    "setting": "Ustawić",
    "password": "Zmień hasło",
    "device_management": "Zarządzanie sprzętem",
    "rate": "Ustawienie stawki",
    "recharge": "Ustawienie ładowania",
    "Raw_data": "Analiza danych surowych",
    "manufacturer_code": "Kod fabryczny",
    "protocol_operation": "Narzędzie do obsługi protokołu",
    "record": "Rekord ladowania",
    "Manufacturer": "Zarządzanie producentem",
    "alarm": "Dać alarm",
    "Protocol_instruction": "Zarządzanie instrukcjami protokołu",
    "firmwarenew": "Zarzadzanie Firmware",
    "adaptiveFirmware": "Adaptacyjne Oprogramowanie Sprzętowe",
    "intelligenceUpgrade": "Inteligentna aktualizacja",
    "intelligenceUpgradeTitle": "Brak dostępnej paczki aktualizacji, proszę skontaktować się z producentem",
    "intelligenceUpgradeTitle1": "Proszę potwierdzić, czy urządzenie ma przeprowadzić inteligentną aktualizację?",
    "intelligenceUpgradeTitle2": "Nie znaleziono pasującej paczki aktualizacji",
    "firmware": "Domyślna aktualizacja oprogramowania firmware",
    "email": "Ustawienia skrzynki mailowej",
    "myDevice": "Mój sprzęt",
    "overview": "Przegląd",
    "protocol_change": "Zmiana protokołu pozyskiwania danych",
    "functionalApplication": "Zastosowanie funkcjonalne",
    "mobile": "Ustawienia telefonu",
    "pay": "Przebieg ladowania",
    "personal": "Dane osobowe",
    "datalogger_list": "Lista kolekcji",
    "alarmSetting": "Ustawienia alarmu",
    "home": "strona główna",
    "recharge_management": "Zarządzanie ładowaniem",
    "browseAccount": "Zarządzanie podrachunkami",
    "manufacturer_account": "Rachunek producenta",
    "cloudsUpgrade": "Aktualizacja chmury",
    "device_function": "Funkcja zarządzania sprzętem",
    "Password_maintenance": "Utrzymanie hasła elementu kontrolnego",
    "KEY_List": "Lista kluczy",
    "strategy": "Lokalna strategia modernizacji",
    "basic": "Podstawowe informacje",
    "device": "sprzęt",
    "account": "Rachunek",
    "type_code": "Kod typu urządzenia do pozyskiwania danych",
    "actionLog": "Dziennik operacji"
  },
  "account": {
    "cancel": "Anuluj",
    "Delete": "Usuń",
    "enterHome": "Wprowadź stronę główną",
    "reason1": "Urządzenie nie ma obecnie dostępnych danych",
    "reason": "Przyczyną niewyświetlania wykresu może być:",
    "role1": "Typ użytkownika:",
    "reason2": "Protokół urządzenia nie posiada pól parametrów wytwarzania, zużycia energii, zakupu, sprzedaży, ładowania i rozładowania",
    "projects": "Projekt",
    "reason3": "Protokół urządzenia nie posiada pól parametrów wytwarzania energii, mocy obciążenia, mocy baterii i mocy sieci",
    "resetPwdSuc": "Resetowanie hasła pomyślne",
    "newPwd": "Nowe hasło",
    "deleteSuc": "Usuwanie zakonczone sukcesem",
    "binding": "wiążące",
    "Edit": "Edycja",
    "groupsuccess": "Operacja grupowania udana!",
    "createSuc": "Konto utworzone pomyślnie",
    "generalAccount": "Rachunek zwykły",
    "Individual_allocation": "Przydział indywidualny",
    "password": "Hasło kamery",
    "enablesuccess": "Udało się włączyć!",
    "enable": "Włącz",
    "searchPro": "Szukaj projektów",
    "accountManage": "Zarządzanie kontem",
    "relatedOwner": "Dodaj użytkownika podrzędnego",
    "confirmpassword": "Potwierdź hasło",
    "nickname1": "Nazwa użytkownika:",
    "Assigned_successfully": "Przydział pomyślny",
    "Confirm_assignment": "Potwierdź przydział do",
    "selectUserType": "Proszę wybrać typ użytkownika",
    "PNNum": "Numer cześci",
    "devices": "Sprzęt tajwański",
    "deletegroup": "Usunieto z grupy ",
    "adminRelated": "Proszę wybrać administratora",
    "createAccount": "Utwórz konto",
    "title_info1": "Proszę wprowadzić poprawny numer telefonu",
    "operate": "Operacja",
    "groupManage": "Zarzadzanie grupą",
    "Distribution_method": "Metoda alokacji",
    "IsIt": "Czy to w porządku?",
    "userAccount": "Użytkownik",
    "deleteUser": "Usuń konto",
    "projectNum": "Liczba projektów",
    "deletegroupsuccess": "Skutecznie usunięto z grupy!",
    "afterEnable": "Aktywne po wznowionym zalogowaniu , zobacz lub modyfikuj zawartość konta",
    "changeGroupSuc": "Grupowanie mobilne pomyślnie",
    "role": "Typ użytkownika",
    "disablesuccess": "Wyłączony z powodzeniem!",
    "groupto": "Grupa w ",
    "Distribution_collector": "Przypisz kolekcję",
    "confirmDisable": "Na pewno wyłączysz tego użytkownika?",
    "accountStatus": "Stan użytkownika ",
    "title_pwd1": "Proszę wprowadzić hasło o 6-32 cyfr",
    "groupAccount": "grupowanie",
    "defaultGroup": "Grupa acquiscencji",
    "title_pwd2": "Proszę ponownie wprowadzić nowe hasło",
    "nickname": "Pseudonim użytkownika",
    "password1": "Hasło użytkownika:",
    "email": "Adres emial",
    "order_check": "sprawdzenie",
    "relatedSuccess": "Stowarzyszenie udane",
    "Deletesuccessfully": "Konto usunięte pomyślnie!",
    "powerStationOwner": "Właściciel systemu PV",
    "title_mobile": "Proszę wprowadzić 11-cyfrowy numer telefonu",
    "err_orderNum": "Są rzeczy w kolejności",
    "tooltipContent": "Administratorzy mogą przypisać wszystkie zbieracze danych w ramach zamówienia do podległego dystrybutora na podstawie numeru zamówienia",
    "distributor": "Dystrybutor",
    "title_pwd": "Proszę wprowadzić poprawne hasło",
    "Allocation_result": "Wyniki alokacji",
    "confirm": "Ok",
    "ownedDevices": "Posiadanie sprzętu",
    "title_info": "Proszę wprowadzić poprawny adres e-mail",
    "resetPwd": "Reset hasła",
    "activeStatus": "Poziom aktywności",
    "createTime": "Czas utworzenia",
    "placeholder1": "Proszę wprowadzić nazwę użytkownika/numer telefonu",
    "disable": "Wyłącz",
    "accounts": "Użytkownik",
    "lastLogin": "Ostatnie logowanie",
    "allGroup": "Wszystkie grupy",
    "confirmpassword1": "Potwierdź hasło:",
    "editUser": "Edycja użytkownika",
    "cannotRedirect": "To konto nie jest rachunkiem magazynowym energii i nie może być przekierowane",
    "modifiedsuccess": "Informacje użytkownika zmodyfikowane pomyślnie!",
    "email1": "Email",
    "manageAccount": "konto administratora",
    "Order_allocation": "Przydział zleceń",
    "finish": "kompletny",
    "dataogger_swithTip": "Czy to konto może mieć uprawnienia do dodawania kolekcjonerów danych",
    "group": "grupowanie",
    "changeGroup": "Przenieś grupy do:",
    "limitFormat": "Tylko pliki w formatach \"xlsx\" i \"xls\" mogą być przesyłane",
    "ascription": "przypisanie",
    "ascriptionSuccess": "Przynależność z powodzeniem",
    "ascription_result": "Wynik atrybucji",
    "newPwd1": "Nowe hasło:",
    "group1": "grupowanie:",
    "disableSuc": "Wyłączono pomyślnie",
    "currentTotal": "Obecnie łącznie",
    "uselists": "Lista zarządzania użytkownikami",
    "powerStationViewer": "Przeglądarka systemu PV",
    "afterDisable": "PO zakazanej operacji konto nie bedzie możliwe do zalogowania , nie bedzie możliwe przegladanie i modyfikowanie zawartości  tego konta",
    "unclassified": "Niezgrupowane",
    "submit": "Przesłać",
    "newPwdEmpty": "Nowe hasło nie może być puste, proszę je wypełnić!",
    "accountName": "Nazwa użytkownika",
    "pwdresetsuccess": "Zresetowanie hasła pomyślne!",
    "order_number": "Numer zamówienia",
    "mobile1": "telefon komórkowy:",
    "admin": "Administrator",
    "riyueyuan_lineSonAdmin": "Podadministrator linii produkcyjnej",
    "riyueyuan_SonAdmin": "Podadministrator",
    "plantOwner": "Właściciel systemu PV",
    "accountName1": "nazwa użytkownika:",
    "accountName2": "Wprowadź jednego użytkownika",
    "Batch_allocation": "Przydział partii",
    "deviceNum": "Liczba urządzeń",
    "chooseGroup": "Proszę wybrać grupę",
    "editAccount": "Edytuj konto",
    "title_edit": "Proszę wprowadzić informacje do edycji",
    "notRecovered": "Po usunięciu, nie będzie można go odzyskać",
    "placeholder": "Wyszukaj nazwę użytkownika/numer telefonu",
    "accountRole": "rola",
    "Ple_orderNum3": "Kolekcjoner, potwierdź przydział do",
    "Ple_orderNum2": "Są rzeczy w tej kolejności",
    "Ple_orderNum": "Proszę wprowadzić numer zamówienia",
    "Ple_orderNum1": "Proszę wprowadzić poprawny numer zamówienia",
    "lastLoginTs": "Ostatni czas logowania",
    "mobile": "Telefon komórkowy",
    "accountGroup": "Grupy użytkowników",
    "nodata": "Brak danych obecnie dostępnych",
    "allTypeUser": "Wszystkie rodzaje użytkowników",
    "confirmDelete": "Na pewno usuniesz?",
    "confirmEnable": "Czy na pewno włączysz tego użytkownika?",
    "dataloggerNum": "Liczba datalogerów",
    "allAccount": "Wszyscy użytkownicy",
    "err_orderNum1": "Kolekcjoner został związany. Proszę potwierdzić, że kolekcjoner w zamówieniu nie jest związany",
    "accountList": "Lista kont",
    "dataogger_swith": "Czy można dodać rejestrator danych",
    "account_number": "Numer rachunku",
    "Role_authority": "Jurysdykcja",
    "authority_Management": "Zarządzanie uprawnieniami",
    "Related_roles": "Powiązane role",
    "Ple_role1": "Proszę wybrać powiązaną rolę",
    "Ple_role2": "Proszę wprowadzić nazwę/ID roli",
    "Add_role": "Dodaj nową rolę",
    "Edit_role": "Edytuj rolę",
    "Role_id": "Identyfikator roli",
    "Role_name": "Nazwa roli",
    "Ple_role3": "Proszę wprowadzić nazwę roli",
    "Role_des": "Opis roli",
    "Ple_role4": "Proszę wprowadzić opis roli",
    "module": "Modułowy",
    "First_page": "Strona",
    "Secondary_page": "Strona druga",
    "Function_points": "Funkcja",
    "Remove_role": "Usuń rolę",
    "Ple_role5": "Proszę sprawdzić uprawnienia konta",
    "No_permission_prompt": "Brak zgody, proszę skontaktować się z administratorem wyższego szczebla",
    "Ple_role6": "Nazwa roli już istnieje, proszę ponownie wprowadzić",
    "limit_UserTypeNum": "Przekroczenie limitu, ten typ konta już istnieje",
    "limit_UserTypeDataPermission": "Konta dealerów nie mogą powiązać ról z wybranymi uprawnieniami do danych.",
    "edit_limit_UserTypeDataPermission": "Rola jest powiązana z kontem dystrybutora i uprawnienia do danych nie mogą być edytowane.",
    "dataPermission": "Uprawnienie do danych",
    "functionalPermission": "Uprawnienie funkcyjne",
        "unbind_tips": "Urządzenie nie jest powiązane z właścicielem, najpierw powiąż właściciela"
  },
  "alarm": {
    "Alarm_Msg": "Nowe wiadomości",
    "Alarm_Event": "Zdarzenie alarmowe",
    "Intro_Msg": "Przewodnik dla początkujących",
    "Alarm_Status": "Status przetwarzania",
    "alarmNum": "Liczba alarmów",
    "alrmDes": "Opis alarmu filtruj",
    "deviceFilter": "Urządzenia filtrujące",
    "tips": "Podpowiedzi",
    "view": "zobacz",
    "back": "Powrót",
    "exportArchive": "Eksportuj zarchiwizowany alarm",
    "archiveRecord": "Archiwum",
    "archiveTip": "Lista zawiera wszystkie nieprzetworzone alarmy i przetworzone rekordy z ostatnich 7 dni",
    "Device_PN": "Numer PN urządzenia do pozyskiwania danych",
    "Battery": "Bateria",
    "Alarm_Type": "Typ alarmu",
    "warning": "Alarm",
    "device_address": "Adres urzadzenia",
    "details": "szczegółowe",
    "Camera": "Kamera",
    "deviceType": "Typ urządzenia",
    "curSelected": "Aktualnie wybrany",
    "Status": "Status",
    "all": "bądź wszystkim",
    "untreated": "Nieprzetworzone",
    "alrmType": "Typy alarmów filtrujących",
    "delete_alarm": "Na pewno chcesz usunąć ten alarm?",
    "Delete_selected": "Usuń wybrane",
    "Microinverter": "Mikroinwerter",
    "faultTitle": "Liczba usterek w ciągu ostatnich siedmiu dni",
    "warningTitle": "Liczba alarmów w ciągu ostatnich siedmiu dni",
    "alarmDevice": "Informacje o wyposażeniu",
    "Prevent_arcing_island": "Zapobieganie lukom i  wyspowaniu",
    "device_Warning": "alarm sprzętu",
    "Occurrence_time": "Czas wystąpienia",
    "device_Error": "Błąd sprzętu",
    "Alarm_Message": "Twój",
    "Alarm_List": "Lista Alarów",
    "alarmStatus": "Statystyki stanu przetwarzania alarmów",
    "combining_manifolds": "Skrzynka przyłączeniowa",
    "allAlarm": "Łączna liczba zdarzeń alarmowych",
    "Device_Name": "Nazwa urządzenia",
    "Device_SN": "Numer seryjny Urzadzenia",
    "Today_Alarm": "Dzisiejsza liczba alarmów",
    "Alarm_Read": "Przeczytałeś wszystkie powiadomienia alarmowe",
    "Close": "Wyłączenie",
    "alarmDetails": "Szczegóły alarmu",
    "device_alias": "Alias urządzenia",
    "Alarm_data": "W tej chwili nie ma żadnych najnowszych wiadomości!",
    "ruleManage": "Zarządzanie regułami filtrowania alarmów",
    "device_Fault": "awaria sprzętu",
    "deletes": "Usuń",
    "User": "Należy do użytkownika",
    "Cancel": "Anuluj",
    "timeSlot": "przedział czasowy",
    "faultNum": "Liczba usterek",
    "Confirm": "Potwierdź",
    "ruleNew": "Dodaj nowe reguły",
    "Alarm_Describe": "Opis alarmu",
    "Operation": "Operacja",
    "storage": "Magazyn energii",
    "alarmInfo": "Sytuacja alarmowa",
    "error": "Błąd",
    "Alarm_Message1": "Urządzenie pojawia się",
    "offline": "Offline",
    "Plant": "Powiązany system PV",
    "clearHistory": "Wyczyść historię",
    "ruleName": "Nazwa reguły",
    "Charger": "充电器",
    "Alarm_Code": "Kod alarmu",
    "more": "Więcej",
    "Device_Type": "Typ urządzenia",
    "endtime": "Czas zakończenia",
    "fault": "Niepowodzenie",
    "monitor": "Monitor środowiskowy",
    "inverter": "Inwerter",
    "filterHistory": "Historia filtrów",
    "processed": "Przetworzone",
    "_Data": "Dane artykułów",
    "smart_meters": "Inteligentny miernik",
    "deleted_successfully": "Alarm usunięty pomyślnie!"
  },
  "device": {
    "cancel": "Anuluj",
    "devcode_required": "Proszę wprowadzić kod urządzenia",
    "year": "Zużycie energii elektrycznej w tym czasie",
    "deleteSuc": "Usuwanie zakonczone sukcesem",
    "pageSize": "Wyświetlanie na stronie",
    "noDataPlease": "Brak danych, proszę wybrać nowy czas",
    "Battery_voltage": "Napięcie akumulatora",
    "delete_tips_2": "Czy to dane?",
    "select_file": "Proszę wybrać oprogramowanie firmware",
    "delete_tips_1": "Potwierdź znacznik czasu usunięcia:",
    "confirm_deldte": "Na pewno usuniesz?",
    "brandDevice": "Urządzenie",
    "familyLoad": "Obciążenie domowe",
    "solar": "Fotowoltaika",
    "hostname_required": "Nazwa domeny nie może być pusta",
    "edit_ctrl_title": "Edytuj utrzymanie elementów sterowania urządzeniem",
    "clear_data": "Wyczyść dane",
    "universal_firmware": "Uniwersalne oprogramowanie firmware",
    "device_rerolling": "Ponowne toczenie urządzeń",
    "select_brate": "Proszę wybrać szybkość budowy",
    "Send_Command": "Wyślij polecenie",
    "showParam": "Parametry wyświetlania",
    "gridPower": "Moc sieci",
    "brand3": "Maszyna zintegrowana do magazynowania energii",
    "upgrade": "Zbiorowa aktualizacja",
    "brand2": "Inwerter",
    "In_Upgrading": "Sprzęt lub urządzenie do pozyskiwania danych jest już aktualizowane",
    "edit": "Edycja",
    "brand1": "Inwertor poza siecią",
    "brand0": "Pozostałe urządzenia do magazynowania energii",
    "analysis": "analiza parametrów",
    "Cumulative_income": "Łączne dochody z wytwarzania energii",
    "pvPower": "Wytwarzanie energii",
    "cur_thismonth": "W tym miesiącu",
    "modify_alias": "Edytuj sprzęt",
    "Device_sn": "Numer seryjny urządzenia",
    "domain": "nazwa domeny",
    "device_code": "Protokół komunikacyjny",
    "alternator": "alternator",
    "detail": "Zobacz szczegóły",
    "charged": "Zdolność ładowania",
    "device": "Urządzenie",
    "cur_day": "dzień",
    "datalogger_pn": "Numer datalogera",
    "Equipment_agreement": "Umowa na sprzet",
    "loadPower": "Moc obciążenia",
    "edate_required": "Koniec czasu nie może być pusty",
    "standby": "Tryb czuwania",
    "timeSlot": "przedział czasowy",
    "select_type": "Proszę wybrać typ oprogramowania",
    "alarmInfo": "Informacje o alarmie",
    "battery": "Bateria",
    "device_synchronization": "Synchronizacja urządzeń",
    "Successfully_modified": "Zmodyfikowano pomyślnie",
    "offline": "Offline",
    "default": "Domyślnie",
    "buyProfit_Today": "Codzienne koszty zakupu energii elektrycznej",
    "copy_val_no": "Kopiowanie nie powiodło się",
    "Upgrading": "Aktualizacja w toku, proszę poczekać",
    "copy_val_yes": "Kopiowanie pomyślne",
    "Send_fail": "Nie udało się wydać polecenia",
    "control_firmware_bms": "Oprogramowanie firmware BMS",
    "SN": "Numer seryjny urządzenia",
    "person_authority": "Organ właściciela",
    "distribute": "Wydane",
    "match_tips": "Numer seryjny i adres komunikacyjny dwóch urządzeń zostały nieprawidłowo wypełnione",
    "clause": "Dane szczegółowe",
    "debug_suc": "Debugowanie pomyślne",
    "set": "Ustawienie",
    "refresh": "Odśwież",
    "inverter": "Inwerter",
    "clear_val": "wyeliminować",
    "protocolStatistic": "Statystyki protokołu komunikacyjnego",
    "dataloggerList": "Lista kolekcji",
    "delete_tips": "Czy na pewno usuniesz hasło do niestandardowego elementu kontroli urządzenia domeny?",
    "buyProfit_Total": "Całkowite wydatki na zakup energii elektrycznej",
    "confirm": "Ok",
    "queryUpgrade": "Zbiorowy proses sprawdzenia aktualizacji",
    "device_cloudsUpgrade": "Aktualizacja urządzeń opartych na chmurze",
    "Debugfail": "Debugowanie nie powiodło się, urządzenie jest offline",
    "chart": "Wykres danych",
    "Sn_deviceName": "SN / Nazwa urządzenia / PN / Użytkownik",
    "current_val": "Aktualna wartość",
    "upFailDevice": "Aktualizacja nieudanych urządzeń",
    "copy_val": "kopia",
    "device_code1": "Kod urządzenia",
    "User_belong": "Należy do użytkownika",
    "deviceName": "Nazwa urządzenia",
    "frequency": "częstotliwość",
    "cloudUpgrade": "Aktualizacja chmury",
    "Device_pn": "PN urządzenia:",
    "generated": "Wytwarzanie energii",
    "deviceList": "Lista urządzeń",
    "warning": "Ostrzeżenie",
    "device_address": "Adres urzadzenia",
    "energyFlow": "Schemat przepływu energii",
    "upgrade_brate": "Szybkość budowy:",
    "batteryPower": "Moc akumulatora",
    "firmware_type": "Typ oprogramowania:",
    "add": "Dodaj",
    "dataTips": "Aktualne urządzenie jest offline i nie ma dostępnych danych w czasie rzeczywistym.",
    "upDevice": "Aktualizacja urządzenia",
    "statistic": "Statystyki",
    "loadMore": "Załaduj więcej",
    "firmware_package_message": "Proszę wybrać oprogramowanie firmware",
    "Please_parameter": "Proszę wybrać parametr",
    "Allthemachines": "Wszystkie urządzenia",
    "deviceNo": "Nie dodałeś jeszcze urządzenia",
    "firmware_step_message": "Proszę wprowadzić kroki początkowe",
    "pro": "projekt",
    "deviceInfo": "Informacje o wyposażeniu",
    "moveSuc": "Mobilność pomyślna",
    "create_ctrl_title": "Utwórz utrzymanie elementów sterowania urządzeniem",
    "month": "Miesięczne zużycie energii elektrycznej",
    "return_content": "Zwróć zawartość:",
		"ownerShip": "Zmiana właściciela",
    "oldOwner": "Poprzedni właściciel:",
    "nweOwner": "Nowy właściciel:",
    "loading": "Ładowanie...",
    "moreLoading": "Przewiń, aby załadować więcej",
    "pleaseDate": "Proszę wybrać datę",
    "baudrate_message": "Proszę wybrać szybkość budowy",
    "unfollow": "Anuluj obserwowanie",
    "upgradeProgress": "Bieżący postęp aktualizacji",
    "file_fist": "Proszę najpierw wybrać oprogramowanie do aktualizacji",
    "device_model": "Model wyposażenia",
    "followList": "Śledź urządzenia",
    "delete_device_chart_data": "Usuń dane wykresu urządzenia",
    "continueUpgrade": "Kontynuuj modernizację",
    "device_name": "Nazwa urządzenia",
    "Magnification": "Współczynnik powiększenia",
    "Today_income": "Dzienne dochody z wytwarzania energii elektrycznej",
    "addUpgradeSuccess": "Dodanie zakonczone sukcesem",
    "numberRlues": "Proszę wprowadzić poprawną liczbę kroków",
    "normal": "Zwykły",
    "sold": "Sprzedaż energii elektrycznej",
    "overview": "Przegląd statystyczny",
    "optionTitle": "Wybrane",
    "coll_alias": "Nazwa KOlektora danych",
    "device_upgradeStatus": "Status aktualizacji",
    "relay": "Mikro odwrotny",
    "consumption": "Obciążenie DC",
    "search_btn": "zapytanie",
    "Check_all": "Sprawdź wszystkie",
    "cur_month": "miesiąc",
    "noAuth": "Brak użytkownika powiązanego, brak uprawnień do oglądania",
    "data_tips": "Parametry niewypełnione w pełni",
    "step": "Kroki rozpoczęcia:",
    "edit_control": "Edycja uprawnien kontroli urzadzenia",
    "noDate": "Nie można wybrać przyszłych dat",
    "device_upgrade": "Aktualizacja oprogramowania sprzętowego urządzenia",
    "chosenParam": "Wybrane parametry",
    "updatefail": "Aktualizacja nie powiodła się, kolektor może być offline lub sprawdzić, czy komunikacja z kolektorem jest normalna",
    "device_pn": "Numer cześci",
    "administrator_cansee": "Wybór uprawnień oznacza, że jest widoczny dla administratorów, a jej brak oznacza, że nie jest widoczny.",
    "Instruction": "Instrukcje:",
    "device_upgradeTime": "Czas akyualizacji",
    "Send_suc": "Instrukcja wydana pomyślnie",
    "Cancel_all": "anuluj wszystkie",
    "discharged": "Zdolność rozładowania",
    "communication_firmware": "Oprogramowanie komunikacyjne",
    "cur_today": "Dzisiaj",
    "deviceDebug": "Debagowanie sprzetu",
    "generation": "Panele fotowoltaiczne",
    "update_first_data_time": "Zmień czas pierwszej transakcji urządzenia",
    "delete_domain": "usuń nazwę domeny",
    "Datalogger_belong": "Należy do datalogera",
    "field": "Kontrola polowa",
    "defaultUpgrade": "Domyślna aktualizacja",
    "reset": "Zresetuj",
    "devaddr_again": "Proszę ponownie wpisać swój adres pocztowy",
    "person_cansee": "Wybierz przedstawiciela uprawnień: widoczny dla właścicieli, nie wybrany przedstawiciel nie widoczny.",
    "device_alias": "Nazwa sprzętu:",
    "minSelect": "Należy sprawdzić co najmniej jeden parametr",
    "deviceUpgradeProgress": "Postępy modernizacji sprzętu",
    "maxSelect": "Można wybrać tylko do 7 parametrów",
    "Output_table": "Tabela wyjściowa",
    "Upload": "Ładowanie firmware",
    "Input_form": "Tabela wejściowa",
    "upgrade1": "Aktualizacja",
    "more": "Więcej Akcji",
    "one_click_read": "Przeczytaj w jednym kliknięciu",
    "device_code_form": "Protokół komunikacji:",
    "power": "Moc",
    "device_sn": "Numer seryjny Urzadzenia",
    "delete_device_data": "Usuń dane urządzenia",
    "bought": "Kup energię elektryczną",
    "cur_thisyear": "w tym roku",
    "upSuccessDevice": "Udane uaktualnienie urządzeń",
    "proList": "Lista projektów",
    "serial_number": "SN urządzenia:",
    "tips1": "Wskazówka: Podczas synchronizacji z MongoDB do MySQL wytwarzanie energii urządzenia jest nieprawidłowe. Proszę cofnąć ją i zsynchronizować później (może to niekoniecznie skutkować prawidłowym wytwarzaniem energii, może być spowodowane nieprawidłowymi szczegółami danych).",
    "tips2": "Wskazówka: Proszę ponownie wprowadzić numer seryjny urządzenia i adres komunikacyjny",
    "tips3": "Porada: Po usunięciu szczegółów danych nie można ich ponownie znaleźć, a odpowiednich danych wykresu nie można obliczyć na stałe",
    "tips4_2": "Proszę zwrócić uwagę na strefę czasową urządzenia, dodać odpowiedni czas na podstawie bieżącej strefy czasowej i ponownie wprowadzić numer seryjny urządzenia i adres komunikacyjny",
    "tips4_1": "Wskazówka: Aktualna strefa czasowa urządzenia to",
    "grid": "Sieć energetyczna",
    "control_firmware_slavmcu": "Oprogramowanie firmware SlavMCU",
    "report": "Formularz raportu",
    "upgradeType": "Metoda uaktualnienia:",
    "device_upgrade1": "Ostatni rekord aktualizacji",
    "uploadSuccess": "Przesyłanie pomyślne",
    "SN_required": "Proszę wprowadzić numer SN",
    "Current_data": "Bieżące dane",
    "Upload1": "Prześlij nowe oprogramowanie firmware",
    "Send_Input": "Proszę wprowadzić wartość operacji, która ma zostać wydana",
    "device_type": "Typ urządzenia",
    "selecParameters": "Wybrane parametry",
    "used": "Zużycie energii elektrycznej",
    "System_Failed": "Z powodu nieprawidłowości komunikacyjnych lub innych przyczyn system nie uruchomił procesu aktualizacji urządzenia",
    "Unit": "Jednostka",
    "modifySuc": "Zmodyfikowano pomyślnie",
    "cur_year": "rok",
    "firmware_type_message": "Proszę wybrać typ",
    "such_as": "Na przykład: AA BB CC DD EE FF",
    "day": "Moc w czasie rzeczywistym",
    "obtain": "uzyskać",
    "all": "Całkowite zużycie energii elektrycznej",
    "device_status": "Stan urządzenia",
    "read": "odczyt",
    "deleteDevice": "Usuń urządzenie",
    "update_suc": "Aktualizacja zakończona sukcesem",
    "sn_is_required": "SN nie może być pusty",
    "admin_authority": "Uprawnienia administratora",
    "SN_again": "Proszę wpisać SN ponownie",
    "continueUpgradeSuccess": "Kontynuuj uaktualnianie i dodawaj pomyślnie",
    "send": "Wyślij instrukcje",
    "control_firmware1": "Oprogramowanie sterowania 1",
    "datalogger": "Kolektor danych",
    "control_firmware2": "Oprogramowanie sterowania 2",
    "device_upgradeProgress": "Proces aktualizacji",
    "Operation": "Operacja",
    "sdate_required": "Czas rozpoczęcia nie może być pusty",
    "delete": "Usuń",
    "addUpgrade": "Dodaj zadanie aktualizacji",
    "Device_Offline": "Urządzenie lub rejestrator danych jest offline",
    "Field_Name": "Nazwa pola",
    "device_upgradeFirmware": "Wybierz pakiet oprogramowania, aby uaktualnić urządzenie",
    "Voltage": "Napięcie",
    "Update_Completed": "Zakończona modernizacja",
    "parameter": "Parametr",
    "device_continueUpgrade": "Kontynuuje modernizacja sprzętu",
    "moveResults": "Wyniki mobilne",
    "value": "wartość",
    "chooseProtocol": "Wybierz Protokół:",
    "sellProfit_Today": "Dzienne dochody ze sprzedaży energii elektrycznej",
    "sellProfit_Total": "Łączne dochody ze sprzedaży energii elektrycznej",
    "optionalParam": "Parametry opcjonalne",
    "fileExceed": "Plik jest zbyt duży",
    "optionTitle3": "Proszę nie wybierać opcji z więcej niż dwóch różnych jednostek",
    "debug": "Debugowanie",
    "Electric": "Prąd",
    "devaddr_required": "Proszę podać swój adres pocztowy",
    "fault": "Niepowodzenie",
    "control": "Kontrola",
    "select_firmware": "Oprogramowanie sprzętowe:",
    "follow": "następuj",
    "upBatchDeviceTip": "Uwaga: Aktualizacja wsadowa odnosi się do aktualizacji oprogramowania firmware tego samego urządzenia na wiele urządzeń. Jeśli nie jesteś pewien, który oprogramowanie jest odpowiedni dla każdego urządzenia, wybierz ostrożnie!",
    "cloudsUpgrade": "Aktualizacja chmury",
    "device_upgradeName": "Zaktualizuj nazwę oprogramowania firmware",
    "instruction_response": "Wysyłam polecenie, czekam na odpowiedź",
    "error1": "Tylko pliki w formatach \". bin\" i \". hex\" mogą być przesyłane",
    "optionTitle1": "termin",
    "dataview": "Parametry czasu rzeczywistego",
    "optionTitle2": "Wybór parametrów sprzętu nie może przekraczać 4",
    "optionTitle4": "Wybór parametrów sprzętu nie może przekraczać 12",
    "PN": "Kodowanie urządzenia monitorującego"
  },
  "group": {
    "cancel": "Anuluj",
    "Delete": "Usuń",
    "note": "Powiadomienia grupy",
    "entername": "Proszę wprowadzić nazwę grupy",
    "deletegroup": "Usuń grupę",
    "deletesuc": "Grupa usunięta pomyślnie",
    "deleteConfirm": "Na pewno chcesz usunąć tę grupę?",
    "Operate": "Operacja",
    "Group_name": "Nazwa Grupy",
    "Create_groups": "Uw€ż grupę",
    "editsuc": "Edycja grupy pomyślna",
    "Group_name1": "Nazwa grupy:",
    "confirm": "Potwierdź",
    "userCount": "Liczba użytkowników grupy",
    "Groups_list": "Lista grup",
    "Edit_groups": "Edycja grupy",
    "creatsuc": "Tworzenie grupy pomyślne",
    "finish": "kompletny",
    "note1": "Uwagi grupy:"
  },
  "datalogger": {
    "cancel": "Anuluj",
    "unbound": "Niezwiązane",
    "Normal1": "Status online",
    "resetTitle1": "Czy na pewno zresetujesz rejestrator danych? (1: Udostępnij go do ponownej rejestracji, 2: Wyczyść urządzenia podrzędne, 3: Usuń wszystkie dane pod kolektorem)",
    "search_PN": "Prosze wprowadź numer seryjny",
    "deleteSuc": "Usuwanie zakonczone sukcesem",
    "county": "Powiat",
    "select_file": "Proszę wybrać oprogramowanie firmware",
    "confirm_deldte": "Po usunięciu zbieracza danych nie będziesz już miał uprawnień do zarządzania wszystkimi danymi związanymi z zbieraczem danych",
    "bind": "Wiązanie (modyfikacja)",
    "modification_type": "Modyfikacja typu urządzenia do pozyskiwania danych",
    "buyProfitNew": "Cena zakupu energii elektrycznej",
    "province": "Województwo",
    "clear_data": "Wyczyść dane",
    "postSucc": "Ustawienie pomyślne",
    "location_info": "informacje o pozycji",
    "Status": "Status",
    "datalogger_log": "dziennik",
    "upgrade": "Aktualizacja",
    "edit": "Edycja",
    "timeZone": "Strefa czasowa",
    "unbindDataloggerName": "Odwiąż kolekcję danych",
    "add_suc": "Nowy pomyślnie dodany",
    "nominalPower": "Moc znamionowa",
    "installer": "Dostawca instalacji",
    "18digit": "18-bitowe wiązanie",
    "delResults": "Usuń wynik",
    "datalogger_pn": "PN kolekcjonera danych:",
    "batch_bind_title": "Wiązanie protokołu partii (modyfikacja)",
    "latitude": "Szerokość geograficzna",
    "locationTip": "Miłe przypomnienie: Gdy pozycjonowanie jest niedokładne lub nieskuteczne, dostępne jest ręczne wejście",
    "Firmware_Version": "Firmware",
    "upSuccessDatalogger": "Pomyślnie uaktualnione urządzenie do pozyskiwania danych",
    "postName": "Numer parametru (po przecinku)",
    "resetResults": "Resetuj wynik",
    "bind_title": "Protokół wiążący (zmiana)",
    "bounding_success": "Protokół wiążący udało się!",
    "currency": "Waluta dochodów:",
    "unbingTitle": "Czy na pewno odłączysz rejestrator danych? (1: Rozwiąż administratora dealera; 2: Rewiąż, zaloguj się do odpowiedniego administratora dealera, aby dodać zbieracz danych)",
    "Datalogger_model": "model",
    "new_type": "Dodaj typ urządzenia do pozyskiwania danych",
    "debug_suc": "Debugowanie pomyślne",
    "address": "Położenie urządzenia do pozyskiwania danych",
    "getVal": "Bieżąca wartość:",
    "dataloggerView": "Szczegóły urządzenia do pozyskiwania danych",
    "finishAdding": "Zakończ dodawanie",
    "warehousing_time": "Czas przechowywania",
    "delete_type": "Usuń kod typu kolekcjonera danych",
    "Normal": "Zwykły",
    "shezhi": "Ustawienie",
    "confirm": "Ok",
    "activeStatus": "Status aktywacji",
    "Debugfail": "Debugowanie nie powiodło się, rejestrator danych jest offline",
    "paramSetting": "Ustawienia parametrów",
    "describe": "opis",
    "batch_change": "Zmiana partii",
    "country": "kraj",
    "type_name": "Nazwa typu urządzenia do pozyskiwania danych",
    "getName": "Pobieranie parametrów (po przecinku)",
    "paramVal": "Wartość parametru",
    "empty_prompt": "Brak danych, proszę wprowadzić numer PN lub sprawdzić, czy numer PN został wprowadzony nieprawidłowo",
    "xiafa": "Wydawanie instrukcji",
    "debugeName": "Polecenie:",
    "frequency": "Częstotliwość zbierania",
    "Ple_PN": "Proszę wprowadzić numer PN zbieracza danych",
    "devaddrfail": "Adres komunikacyjny nie może być pusty",
    "transmission": "Czysta przejrzysta identyfikacja transmisji",
    "multi_binding": "Wiązanie partii",
    "longi_lati": "Szerokość i długość geograficzna",
    "finish": "kompletny",
    "install_date": "Czas instalacji",
    "signal": "sygnał",
    "disabledText1": "Proszę wybrać umowę",
    "editSuc": "Pomyślnie zmodyfikowany rejestrator danych",
    "add": "Dodaj urządzenie",
    "Offline1": "Status offline",
    "upBatchDataloggerTip": "Uwaga: Aktualizacja wsadowa odnosi się do aktualizacji tego samego oprogramowania firmware kolektora danych dla wielu kolektorów danych. Jeśli nie jesteś pewien, co do oprogramowania odpowiedniego dla kolektora danych, wybierz ostrożnie!",
    "success_prompt": "Nowy kod dodany pomyślnie!",
    "return_content": "Zwróć zawartość:",
    "district": "Okręg administracyjny",
    "rebootDataloggerName": "Restart urządznia monitorującego",
    "disabledText": "Proszę poczekać na uzyskanie danych później",
    "Datalogger_PN": "Numer PN urządzenia do pozyskiwania danych",
    "generateProfitNew": "Cena wytwarzania energii elektrycznej",
    "Datalogger_Name": "Nazwa Datalogera",
    "file_fist": "Proszę najpierw wybrać oprogramowanie do aktualizacji",
    "addedSuccessfully": "Dodanie zakonczone sukcesem",
    "unbindUsr": "Odwiąż właściciela nieruchomości",
    "paramName": "Nazwa parametru",
    "postVal": "Ustaw wartość:",
    "dataloggerAddress": "Adres",
    "load": "Z zaladowana liczba",
    "addSuc": "Pomyślnie dodany rejestrator danych",
    "fixOnRebootDataloggerName1": "Czy to w porządku?",
    "unbounding_success": "Niewiążący protokół pomyślnie!",
    "generateProfit": "Cena wytwarzania energii elektrycznej:",
    "noNegative": "Proszę wprowadzić liczbę nieujemną",
    "basic_info": "Podstawowe informacje",
    "bound": "Już związane",
    "dataloggerTipName": "Kolekcjoner został dodany, dodaj osobę",
    "add_datalogger": "Dodaj urządzenie do pozyskiwania danych",
    "currentAddress": "Obecny adres:",
    "field_name": "Nazwa pola",
    "timezone1": "Strefa czasowa",
    "addScq": "Dodaj Dataloger",
    "start_address": "Adres rozpoczęcia sondaży",
    "prompt": "Przygotowanie do usunięcia kodu typu kolekcjonera danych",
    "noDate": "Proszę wybrać datę w ciągu trzech dni",
    "resetData": "Resetuj dane",
    "device_upgrade": "Aktualizacja oprogramowania sprzętowego urządzenia",
    "batchAddScq": "Batch Dodaj kolekcjonery danych",
    "updatefail": "Aktualizacja nie powiodła się, kolektor może być offline lub sprawdzić, czy komunikacja z kolektorem jest normalna",
    "heartbeat": "bicie serca",
    "paramPar": "Numer parametru",
    "batch_protocol_change": "Modyfikacja protokołu partii",
    "please_title": "Proszę wpisać \"TAK\", aby potwierdzić reset fabryczny",
    "Instruction": "Instrukcje:",
    "debugeAddr": "Adres urządzenia:",
    "rebootDataloggerSuc": "Urządzenie monitorujące zostało uruchomione ponownie",
    "domain_name": "Nazwa domeny online",
    "datalogger_debug": "Dataloger debugowanie",
    "Flowcard_status": "Status karty drogowej",
    "reAdd": "Dodaj ponownie",
    "protocol_code": "Kodowanie protokołu",
    "connectionInfo": "Informacje o połączeniu",
    "editDatalogger": "Modyfiuj urządzenia monitorujące",
    "Ple_Alias": "Proszę wprowadzić nazwę urządzenia do pozyskiwania danych",
    "unbindResults": "Odwiąż wynik",
    "editResults": "Zmiana wyniku",
    "Offline": "Offline",
    "Communication_balance": "Bilans opłat za komunikację",
    "prompt_codetip": "Kod typu kolekcjonera danych nie może być pusty",
    "sellProfit": "Cena sprzedaży energii elektrycznej:",
    "Datalogger_List": "Lista kolekcji",
    "debugeTitle": "Ustaw debugowanie",
    "deadline_address": "Adres terminu wyborczego",
    "reset": "Zresetuj",
    "Datalogger_type": "Typ urządzenia monitorującego",
    "addResults": "Dodaj wyniki",
    "resetTitle": "Wpisz \"TAK\", aby potwierdzić, że chcesz zresetować rejestrator danych.",
    "getSucc": "Pomyślnie uzyskane",
    "upDatalogger": "Aktualizacja datalogera",
    "type_code": "Kod typu urządzenia do pozyskiwania danych",
    "debugeSucc": "Wydane pomyślnie",
    "batch_protocol_binding": "Wiązanie protokołu partii",
    "continueAdding": "Kontynuuj dodawanie",
    "resetCode": "Proszę wpisać TAK, aby potwierdzić",
    "city": "miasto",
    "notActive": "nieaktywny",
    "Upload": "Ładowanie firmware",
    "prompt_message": "Informacje o przypomnieniu",
    "usr_belong": "Należy do użytkownika",
    "unitProfit": "Cena zużycia energii elektrycznej:",
    "transmission1": "Tryb zbierania lokalnego",
    "transmission2": "Czysty tryb transmisji przejrzystej",
    "basicInfo": "Podstawowe informacje",
    "huoqu": "uzyskać",
    "unbindDataloggerExplain": "Funkcja ta jest głównie dla wygody producentów, aby odłączyć konto testowe (właściciel) od urządzenia do pozyskiwania danych po zakończeniu testu przed wysyłką. Proszę ostrożnie obsługiwać tę funkcję. Po obsłudze klienci będą musieli ponownie przywiązać urządzenie do pozyskiwania danych.",
    "resetDataloggerExplain": "Funkcja ta jest głównie dla wygody producentów do czyszczenia danych testowych w chmurze na urządzeniach. Po zresetowaniu rejestratora danych historycznych urządzenia zostaną usunięte. Po uruchomieniu danych historycznych urządzenia nie można przywrócić. Należy zachować ostrożność!",
    "postTitle": "Ustawienia parametrów",
    "copy": "Kopiowanie pomyślne",
    "datalogger_name": "Nazwa urządzenia do pozyskiwania danych:",
    "cp10": "Proszę wprowadzić nazwę projektu",
    "bingding_status": "Status wiążący",
    "checkVal": "wartość liczbowa",
    "cp2": "Proszę wybrać strefę czasową",
    "cp1": "Proszę wybrać datę instalacji",
    "cp4": "Proszę wybrać walutę dochodu",
    "more": "Więcej",
    "cp3": "Proszę wprowadzić moc znamionową",
    "cp6": "Proszę wybrać projekt, do którego należysz",
    "cp5": "Proszę wprowadzić nazwę urządzenia",
    "cp7": "Proszę wybrać szerokość i długość geograficzną",
    "lonRange": "Liczby o zakresie długości długości od -180 do 180",
    "latRange": "Liczby w zakresie szerokości geograficznej od -90 do 90",
    "upFailDatalogger": "Aktualizacja nieudanego urządzenia do pozyskiwania danych",
    "cp9": "Proszę wpisać bieżący adres",
    "resetSuc": "Reset zakonczony sukcesem",
    "18digit_title": "18-bitowe wiązanie protokołu",
    "modify_datalog": "Zmiana danych o urządzeniu monitorującym",
    "devcode": "Kod producenta sprzętu",
    "com_method": "Metoda komunikacji",
    "debugeVal": "wynik:",
    "sellProfitNew": "Cena sprzedaży energii elektrycznej",
    "Online": "on-line",
    "uploadSuccess": "Przesyłanie pomyślne",
    "location_info1": "informacje geograficzne",
    "buyProfit": "Cena zakupu energii elektrycznej:",
    "resetDataloggerName": "Resetuj urządzenie do pozyskiwania danych",
    "Datalogger_Status": "Status datalogera",
    "editDataloggerName": "Edycja Datalogera",
    "modifySuc": "Zmodyfikowano pomyślnie",
    "Allstate": "Wszystkie stany",
    "getTitle": "Pozyskiwanie parametrów",
    "title_usr": "Ten rejestrator danych nie ma skojarzonego użytkownika",
    "unbound_tips": "Czy na pewno chcesz odłączyć rejestrator danych",
    "create": "ustanowić",
    "such_as": "Na przykład: AA BB CC DD EE FF",
    "longitude": "Długość geograficzna",
    "unbindSuc": "Pomyślne rozwiązanie",
    "upload_err": "Tylko pliki 'xlsx' i 'xls' mogą być przesyłane",
    "transparent_set": "Czysty przejrzysty protokół transmisji",
    "enterPosition": "Wprowadzenie położenia urządzenia do pozyskiwania danych",
    "max_addr": "maksymalny adres",
    "unbindTitle": "Wpisz \"TAK\", aby potwierdzić, że chcesz odłączyć rejestrator danych od aktualnego właściciela terminala.",
    "update_suc": "Aktualizacja zakończona sukcesem",
    "flowCard": "Nie znaleziono ważnej karty",
    "Active": "Aktywowane",
    "unbind": "Rozwiąż wiązanie",
    "copyVal": "Kopiuj wartość",
    "send": "Wyślij instrukcje",
    "income_info": "Informacje o dochodach",
    "timezone": "Strefa czasowa",
    "prompt_desctip": "Nazwa typu kolekcjonera danych nie może być pusta",
    "Operation": "Operacja",
    "upload_tips": "Przypomnienie przyjazne: Format pliku do przesyłania musi być formatem xlsx, xls. Treść przesyłanego pliku można znaleźć na poniższej rysunku",
    "GPRS_traffic": "ruch GPRS",
    "delete": "Usuń",
    "nowNoAdd": "Nie dodano tymczasowo",
    "administrator": "Należy do administartora",
    "Datalogger_method": "Metoda komunikacji",
    "min_addr": "minimalny adres",
    "fileExceed": "Plik jest zbyt duży",
    "reboot": "Uruchom ponownie",
    "input_prompt": "Kod typu kolekcjonera danych to jedna litera",
    "debug": "Debugowanie",
    "fixOnRebootDataloggerName": "Potwierdź ponowne uruchomienie urządzenia do pozyskiwania danych:",
    "select_firmware": "Oprogramowanie sprzętowe:",
    "communication_address": "adres pocztowy:",
    "check": "Sprawdzenie",
    "InstructionType": "Format instrukcji",
    "endMarker": "Znacznik końcowy",
    "noMarker": "Brak znacznika końcowego",
    "noCheck": "Brak sprawdzenia",
    "InstructionIssue": "Wysłanie instrukcji",
    "Insufficient": "Niewystarczająca liczba",
    "deleteTitle": "Usuń urządzania monitorujące",
    "instruction_response": "Wysyłam polecenie, czekam na odpowiedź",
    "unbound_tips1": "Umowa?",
    "error1": "Tylko pliki w formatach \". bin\" i \". hex\" mogą być przesyłane",
    "protocol_name": "Nazwa umowy"
  },
  "auxiliary": {
    "chartSupplement": "Wykresy rzeczywiste",
    "auxiliaryFunction": "Funkcje pomocnicze",
    "realChart": "Po otwarciu wykres wyświetla dane rzeczywiste."
  },
  "rate": {
    "cancel": "Anuluj",
    "buy_Rates": "Stawka zakupu energii elektrycznej:",
    "device_status": "Stan urządzenia",
    "generate_Rates": "Wskaźnik wytwarzania energii elektrycznej:",
    "edit": "Edycja",
    "Income_currencys": "Waluta dochodów:",
    "sell_Rates": "Stawka sprzedaży energii elektrycznej:",
    "datalogger_pns": "PN kolekcjonera danych:",
    "resetSuc": "Reset zakonczony sukcesem",
    "sell_Rate": "Stawka sprzedaży energii elektrycznej",
    "generate_Rate": "Wskaźnik wytwarzania energii elektrycznej",
    "modifySuc": "Zmodyfikowano pomyślnie",
    "confirm": "Ok",
    "buy_Rate": "Stawka zakupu energii elektrycznej",
    "rate": "stawka",
    "rate_list": "Lista stawek",
    "operating": "Operacja",
    "Income_currency": "Waluta dochodów",
    "datalogger_name": "Nazwa Datalogera",
    "datalogger_pn": "Numer datalogera",
    "unbindSuc": "Pomyślne rozwiązanie",
    "status": "Status"
  },
  "map": {
    "datalogger": "Nazwa urządzenia do pozyskiwania danych:",
    "address": "Adres urządzenia:",
    "sn": "SN urządzenia:"
  },
  "constant": {
    "gmt_neg_5": "(GMT -05:00) Czas wschodni (USA i Kanada), Indiana (Wschodni)",
    "gmt_neg_4": "(GMT -04:00) Czas atlantycki (Kanada), Cuyaba, La Paz, San Diego",
    "gmt_neg_7": "(GMT-07:00) Czas górski (USA i Kanada), Chihuahua, La Paz, Mazatlan, Arizona",
    "gmt_neg_6": "(GMT -06:00) Czas centralny (USA i Kanada), Ameryka Środkowa, Meksyk, Monterrey, Guadalajara",
    "gmt_neg_1": "(GMT -01:00) Wyspy Zielonego Przylądka, Azory",
    "gmt_neg_3": "(GMT -03:00) Brasilia, Buenos Aires, Grenlandia, Cayenne",
    "gmt_neg_2": "(GMT -02:00) Środkowy Atlantyk",
    "gmt_11": "(GMT+11:00) Wyspy Salomona, Władywostok, Nowa Kaledonia",
    "gmt_55": "(GMT+05:30) New Delhi",
    "gmt_10": "(GMT+10:00) Brisbane, Guam, Canberra, Melbourne, Sydney",
    "gmt_13": "(GMT+13:00) Nuku'alofa",
    "gmt_12": "(GMT+12:00) Auckland, Wellington, Fidżi, Magadan",
    "gmt_neg_9": "(GMT -09:00) Alaska",
    "gmt_neg_8": "(GMT -08:00) Czas Pacyfiku (USA i Kanada), Dolna Kalifornia",
    "gmt0": "(GMT+00:00) Dublin, Edynburg, Lizbona, Londyn, Casablanca, Czas uniwersalny skoordynowany",
    "gmt_9": "(GMT+09:00) Osaka, Tokio, Seul",
    "gangbi": "Dolar hongkoński (HK$)",
    "gmt_7": "(GMT+07:00) Bangkok, Hanoi, Dżakarta, Nowosybirsk",
    "gmt_8": "(GMT+08:00) Pekin, Chongqing, specjalny region administracyjny Hongkongu, Urumqi, Tajpej, Kuala Lumpur, Singapur",
    "gmt_5": "(GMT+05:00) Islamabad, Karaczi",
    "gmt_6": "(GMT+06:00) Dhaka, Astana, Jekaterynburg",
    "gmt_65": "(GMT +06:30) Myanmar",
    "gmt_neg_11": "(GMT -11:00) Wyspy Samoa",
    "gmt_3": "(GMT+03:00) Bagdad, Kuwejt, Rijad, Nairobi, Teheran",
    "ruidian": "Korona szwedzka (Kr)",
    "gmt_neg_12": "(GMT -12:00) Międzynarodowa linia datowa Zachodnia",
    "gmt_4": "(GMT+04:00) Abu Dhabi, Muskat, Erewań",
    "gmt_1": "(GMT+01:00) Paryż, Madryt, Kopenhaga, Rzym, Wiedeń, Berlin, Amsterdam, Zachodnia Afryka Środkowa",
    "baxi": "Real (R$)",
    "gmt_2": "(GMT+02:00) Amman, Damaszek, Kair, Ateny, Jerozolima, Stambuł",
    "renminbi": "RMB (¥)",
    "lubi": "Rupia indyjska (₹)",
    "gmt_neg_10": "(GMT -10:00) Hawaje",
    "Rand": "Rand Południowoafrykański (R)",
    "moxige": "Peso meksykańskie (Mex$)",
    "yingbang": "Funt brytyjski GBP(£)",
    "Pakistani": "Rupia pakistańska (R)",
    "aoyuan": "Dolar australijski AUD($A)",
    "meiyuan": "Dolar amerykański USD($)",
    "ouyuan": "EURO(€)"
  },
  "cloudsUpgarde": {
    "cloudsFirmwareList": "Lista aktualizacji chmury",
    "cloudsFirmware": "Aktualizacja oprogramowania oprogramowania opartego na chmurze"
  },
  "upgradeManagement": {
    "cancel": "Anuluj",
    "eidt_success": "Edycja pomyślnie",
    "delete_success": "Anuluj pomyślnie",
    "edit_firmware": "Edytuj oprogramowanie firmware",
    "delete_success1": "Usuwanie zakonczone sukcesem",
    "download_firmware": "Pobierz oprogramowanie firmware",
    "download_exception": "Pobierz wyjątek, spróbuj ponownie później",
    "upgrade_file_format1": "Można przesłać tylko format bin/. hex",
    "upgrade_file_format2": "Plik nie może przekraczać 1MB",
    "Upload": "Ładowanie firmware",
    "Firmware_Version": "Numer wersji",
    "firmwareName_empty": "Nazwa oprogramowania nie może być pusta",
    "confirm": "Potwierdź",
    "upgrade_file_format": "Można przesłać tylko format bin/. hex, nie przekraczający 1MB",
    "firmware_name": "Nazwa pakietu oprogramowania sprzętowego",
    "Remarks": "Opis firmware",
    "please_upgrade": "Proszę wybrać przesłanie pliku",
    "download_firmware_prompt": "Na pewno chcesz pobrać ten oprogramowanie firmware?",
    "upload_firmware": "Ładowanie firmware",
    "create": "ustanowić",
    "please_input": "Proszę wprowadzić",
    "firmwareVersion_empty": "Numer wersji nie może być pusty",
    "download_success": "Pobieranie w toku",
    "delete_desc": "Po usunięciu nie będzie można go odzyskać, a strategia aktualizacji wybrana dla tego oprogramowania oprogramowania nie będzie w stanie uaktualnić urządzenia",
    "upgrade_success": "Załadunek firmware zakończony sukcesem",
    "upload_result": "Wynik przesyłania"
  },
  "project": {
    "energyCurrent": "Aktualna moc",
    "tipCard": "karta",
    "energyMonth": "Ilość wytworzonej energii (bieżący miesiąc)",
    "upload": "Przesyłaj obraz",
    "createResults": "Nowy wynik",
    "back": "Powrót",
    "project": "Projekt należący do projektu",
    "createProject": "Nowy projekt",
    "deviceSn": "Numer seryjny Urzadzenia",
    "createSuc": "Nowy utworzony pomyślnie",
    "modifySuc": "Powodzenie",
    "delSuc": "Usuwanie zakonczone sukcesem",
    "upgradeSuc": "Aktualizacja zakończona sukcesem",
    "tipList": "lista",
    "moveSelect": "Przenieś zaznaczone",
    "limit": "(Rozmiar obrazu nie przekracza 1M)",
    "placeholder": "Szukaj nazwy urządzenia PN/SN",
    "defaultProject": "Domyślny projekt",
    "energyDate": "Bieżąca wygenerowana pojemnośc",
    "editSuc": "Edycja pomyślnie",
    "editProject": "Edytuj projekt",
    "move": "ruchy",
    "energyTotal": "Całkowita ilość wytworzonej energii",
    "tipSearchPN": "Wyszukiwanie według urządzenia do pozyskiwania danych",
    "editResults": "Edytuj wyniki",
    "projectRemark": "Opis projeku",
    "manageProject": "zarządzanie projektami",
    "upgradeResults": "Wyniki modernizacji",
    "energyYear": "Ilość wytworzonej energii (bieżący rok)",
    "delResults": "Usuń wynik",
    "delProject": "usuń element",
    "tipSearchSN": "Wyszukiwanie według urządzenia",
    "projectName": "nazwa wpisu",
    "choice": "ekran",
    "projectId": "Identyfikator projektu",
    "moveTo": "Przejdź do"
  },
  "basic": {
    "backTo": "Powrót",
    "Change_email": "Zmień adres e-mail",
    "Email": "Email",
    "uploadAvatar": "Usuń zdjęcie",
    "editNickname": "Zmień pseudonim",
    "bindPhone": "Wiązanie mobilne",
    "bindPhoneTip": "Skonfiguruj telefon komórkowy, który może logować się i pobierać hasła oraz otrzymywać powiadomienia z systemu.",
    "changePwdSuc": "Resetowanie hasła pomyślne",
    "accountSecurity": "Zabezpieczenie rachunku",
    "modifySuc": "Zmodyfikowano pomyślnie!",
    "Personal_info": "Modyfikuj dane osobowe",
    "bindPhoneTipAfter": "Możesz zalogować się i pobrać hasło, a także otrzymywać powiadomienia z systemu.",
    "Nickname": "pseudonim",
    "bindEmailTipBefore": "Wiadomość e-mail już powiązana:",
    "email_code": "Kod weryfikacyjny został wysłany na Twój e-mail, prosimy o dokładne sprawdzenie go",
    "unbinding_Em": "Po odwiązaniu nie będziesz mógł użyć tego e-maila do pobrania hasła!",
    "Bind_phone": "Wiąż telefon",
    "After_bindingPh": "Po podłączeniu telefonu, możesz pobrać hasło za pośrednictwem telefonu",
    "code_frequently": "Kod weryfikacyjny jest wysyłany często, spróbuj ponownie później",
    "finished": "kompletny",
    "Ple_Nickname": "Proszę wprowadzić pseudonim",
    "bindRes": "Wynik wiążący",
    "changeBtn": "Edytuj",
    "setMobile": "Wiążący numer telefonu komórkowego",
    "Ple_email": "Proszę wpisać adres e-mail, aby zostać związany",
    "unbind_Ph": "Na pewno odwiążesz swój numer telefonu?",
    "Bind_email": "Wiąż e-mail",
    "re_enter": "Odzyskaj ponownie",
    "Obtain_code": "Uzyskaj kod weryfikacyjny",
    "Change_phone": "Wymień telefon",
    "noHanzi": "Hasło nie może zawierać chińskich znaków",
    "setNickname": "Ustaw pseudonim",
    "suc_em": "Powiązanie e-maila pomyślne",
    "Save": "konserwacja",
    "basic": "Dane osobowe",
    "bindEmail": "Wiązanie e-maila",
    "mobile_code": "Kod weryfikacyjny został wysłany na Twój telefon, sprawdź go dokładnie",
    "code": "Kod weryfikacji:",
    "setEmail1": "Wiązany adres e-mail",
    "unbind_Em": "Na pewno odwiążesz maila?",
    "Untie_phone": "Rozwiąż telefon",
    "basicInfo": "Podstawowe informacje",
    "changePwd": "Modyfikuj hasło",
    "unbinding_Ph": "Po odwiązaniu nie będziesz mógł używać tego telefonu do pobrania hasła!",
    "bindPhoneTipBefore": "Już podłączony telefon:",
    "Ple_phone": "Proszę wprowadzić numer telefonu, aby zostać związany",
    "Email1": "E-mail",
    "Email2": "E-mail",
    "Select_all": "Przywróć wszystkie zaznaczenia",
    "retry": "próbuj ponownie",
    "editMobile": "Zmień numer telefonu",
    "Ple_code": "Wprowadź kod weryfikacyjny",
    "editEmail": "Zmień adres e-mail",
    "User_name1": "Nazwa użytkownika",
    "personalCenter": "Ustawienia konta",
    "changePwdTip": "Hasło o wysokim zabezpieczeniu może uczynić konto bardziej bezpiecznym. Zalecamy regularne zmiany hasła i ustawienie hasła 6-32 bitowego.",
    "suc_ph": "Pomyślnie powiązany numer telefonu",
    "changeRes": "Zmiana wyniku",
    "bindEmailTip": "Skonfiguruj e-mail, aby zalogować się i pobierać hasła oraz otrzymywać powiadomienia z systemu.",
    "Unbind_email": "Odwiąż wiązanie e-maila",
    "Mobile": "numer telefonu:",
    "Avatar": "Obraz użytkownika",
    "Mobile1": "numer telefonu",
    "Nickname1": "Ksywka",
    "User_name": "nazwa użytkownika:",
    "After_bindingEm": "Po wiązaniu e-maila, możesz pobrać hasło za pośrednictwem e-maila",
    "Nickname_length_tip": "Długość nazwy użytkownika od 2 do 32 bitów"
  },
  "strategy": {
    "cancel": "Anuluj",
    "Not_upgraded": "Nie ulepszono",
    "strategy_number": "Liczba zmodernizowanych obiektów",
    "force_upgrade": "Wymuszenie aktualizacji",
    "strategyIntro": "Przegląd lokalnego procesu aktualizacji",
    "message_baudrate": "Proszę wybrać szybkość budowy",
    "In_effect": "W efekcie",
    "view": "zobacz",
    "strategyUpgrade": "Lista strategii ulepszenia",
    "stategyStep9": "Zobacz status i wyniki aktualizacji urządzenia",
    "message_name": "Proszę wprowadzić nazwę strategii",
    "cancel_strategy": "Anuluj strategię",
    "uprade_name": "Wymuszenie aktualizacji",
    "stategyStep8": "Wyświetl rekordy aktualizacji",
    "edit_strategy": "Strategia edycji",
    "stategyStep7": "Dodaj nową strategię do listy strategii aktualizacji, wybierz aktualizację oprogramowania, ustaw metodę aktualizacji i skuteczność, powiązanie uaktualnionego urządzenia i wygeneruj strategię aktualizacji",
    "stategyStep6": "Dodaj strategię uaktualnienia",
    "message_desc": "Proszę wprowadzić opis strategii",
    "stategyStep5": "Po wejściu strategii w życie aplikacja otrzymuje przypomnienie o aktualizacji i może uaktualnić lokalnie",
    "suggested_upgrade": "Proponuj modernizację",
    "stategyStep4": "Lokalna aktualizacja aplikacji",
    "add_strategy": "Lista strategii ulepszenia",
    "stategyStep3": "Przesyłanie pliku pakietu wersji oprogramowania w lokalnym zarządzaniu oprogramowaniem",
    "stategyStep2": "Dodaj pakiet wersji oprogramowania",
    "End_date": "Data ważności",
    "Upgrade_tip": "Proszę wybrać urządzenie powiązane z polityką",
    "edit": "Edycja",
    "uprade_success": "Aktualizacja zakończona sukcesem",
    "strategy_firmware": "Aktualizuj oprogramowanie",
    "upgrade_remind": "Przypomnienie o aktualizacji",
    "message_timezone": "Proszę wybrać strefę czasową",
    "message_type": "Proszę wybrać typ oprogramowania",
    "go_back": "Powrót",
    "Upgrade_result": "Dodanie zakonczone sukcesem",
    "uprade_time": "Czas akyualizacji",
    "message_uprade_type": "Proszę wybrać typ aktualizacji",
    "stategyDetail7": "Status strategii",
    "message_firmware": "Proszę wybrać oprogramowanie firmware",
    "start_time": "czas wejścia w życie",
    "stategyDetail6": "Proces aktualizacji",
    "stategyDetail5": "Metoda uaktualnienia",
    "uprade_status": "Status aktualizacji",
    "stategyDetail4": "Szybkość budowy",
    "TOP": "Poprzedni krok",
    "completion_strategy": "Kompletna strategia",
    "delete_firmware": "Na pewno chcesz anulować tę polisę?",
    "stategyDetail9": "Czas ważności",
    "Next": "następny krok",
    "stategyDetail8": "czas wejścia w życie",
    "strategy_desc": "Opis strategii",
    "strategy_detail": "Szczegóły strategii",
    "strategy_status": "Status strategii",
    "Yes_started": "Ulepszone",
    "strategy_baudrate": "Szybkość budowy",
    "UpgFirmware": "Lokalne zarządzanie oprogramowaniem firmware",
    "delete_desc": "Po anulowaniu nie będzie można go odzyskać, a wybrana strategia aktualizacji nie będzie w stanie powiadomić urządzenia o aktualizacji",
    "strategy_name": "Nazwa strategii",
    "remind_desc": "Opis przypomnienia",
    "strategy_search": "Kod strategii/nazwa strategii",
    "uprade_type": "Metoda uaktualnienia",
    "uprade_result": "Wyniki modernizacji",
    "associated_device": "Urządzenia powiązane",
    "stategyDetail3": "Typ oprogramowania firmware",
    "stategyDetail2": "Rozmiar pakietu oprogramowania sprzętowego (KB)",
    "stategyDetail1": "Aktualizuj oprogramowanie",
    "upgradeList": "Aktualizuj listę rekordów",
    "message_time": "Proszę wybrać skuteczny czas",
    "expired": "Nieprawidłowe",
    "strategyIntro1": "Wyjaśnienie: Ten moduł funkcji jest przeznaczony tylko do aktualizacji oprogramowania lokalnego Bluetooth. Jeśli chcesz uaktualnić oprogramowanie firmware urządzeń Wi-Fi lub 4G, przejdź do [Zarządzanie urządzeniami z Listą urządzeń: Operacja aktualizacji]",
    "uprade_name1": "Proponuj modernizację",
    "view_strategy": "Zobacz strategię",
    "strategy_code": "Kodowanie strategii",
    "upgrade_strategy_list": "Lista strategii ulepszenia",
    "start_date": "data wejścia w życie",
    "default_desc1": "To urządzenie musi zostać zaktualizowane do wyższej wersji, zanim będzie można go używać. Kliknij \"Wymuszenie aktualizacji\", aby uaktualnić. Proszę nie odłączać połączenia Bluetooth podczas aktualizacji i zapewnić sprawne połączenie z siecią.",
    "strategyInfor": "Informacje o strategii uaktualnienia",
    "policy_information": "Informacje o strategii",
    "end_time": "Czas ważności",
    "strategy_type": "Typ oprogramowania firmware",
    "strategy_upgrade_search": "Urządzenie SN/Urządzenie do pozyskiwania danych PN",
    "confirm": "Potwierdź",
    "strategy_time": "Czas skuteczny",
    "Not_started": "Jeszcze nie rozpoczęto",
    "uprade_fail": "Aktualizacja nie powiodłą sie",
    "stategyDetail": "Nazwa strategii",
    "default_desc": "Domyślny opis",
    "to": "Powrót",
    "limits":     "Wskazówka: w przesłanym pliku kolumna A musi zawierać PN kolektora danych; nagłówek nie jest wymagany — zobacz przykład na poniższym obrazku.",
    "mueas":      "Strategia aktualizacji",
    "upNum":      "Liczba urządzeń do aktualizacji",
    "deletCL":    "Usuń strategię",
    "deletCL_TEST":"Czy na pewno chcesz usunąć tę strategię?",
    "ONE_UP":     "Aktualizacja pojedynczego urządzenia",
    "MO_UP":      "Aktualizacja zbiorcza urządzeń",
    "MO_text": "Pomyślnie zaimportowano",
"MO_tex1": "Zduplikowany",
"MO_tex3": "Nie znaleziono",
"MO_tex2": "Organizacja",
"MO_tex4": "Oprogramowanie jest używane w aktywnej polityce, nie można usunąć",
  },
  "password": {
    "PLConfig_newpassword": "Proszę potwierdzić nowe hasło",
    "Current_password": "Stare hasło:",
    "User_name": "nazwa użytkownika:",
    "PLNew_password": "Proszę wprowadzić nowe hasło",
    "New_password": "Nowe hasło:",
    "Save": "konserwacja",
    "PLCurrent_password": "Proszę wprowadzić stare hasło",
    "editPwdSuc": "Hasło zmienione pomyślnie!",
    "Config_newpassword": "Potwierdź nowe hasło:",
    "loginAgain": "Hasło zmienione pomyślnie, zaloguj się ponownie",
    "Password": "Zmień hasło"
  },
  "recharge": {
    "cancel": "Anuluj",
    "early_warning": "Ostrzeżenie o ważności karty drogowej",
    "orderno": "Numer zamówienia",
    "Recharge_tip4": "Zalecam użytkownikom, którzy zarejestrowali się w serwisie PayPal korzystanie z niego",
    "recharge_type": "typ",
    "Recharge_tip3": "Zalecany dla użytkowników WeChat, którzy już go zainstalowali",
    "Recharge1": "Przebieg ladowania",
    "Recharge_tip6": "Istnieją karty, które nie obsługują ładowania. Proszę skontaktować się z administratorem",
    "rechargeStatus": "Status ponownego ładowania",
    "Recharge_tip5": "WeChat Pay",
    "openWx": "Proszę otworzyć WeChat na telefonie",
    "Hint_language": "Twoje urządzenie ma urządzenie 2G. Na wniosek Ministerstwa Przemysłu i Technologii Informacyjnych, sieci 2G są stopniowo wycofywane, zaleca się zakup i wymianę urządzeń 4G!",
    "rechMoney": "płatność",
    "Recharge": "Doładuj",
    "area_abroad": "międzynarodowy",
        "remedy_title": "Naprawa zamówienia doładowania",
        "upload_tip": "Przypomnienie: Format pliku do przesłania to .txt",
    "Recharge_tip": "Przypomnienie o doładowaniu",
    "Dead_Time": "Czas ważności",
    "domestic": "krajowe",
    "not_for_the_time_being": "Nie przetwarzane tymczasowo",
    "Hint_language1": "Jeśli napotkasz jakiekolwiek problemy podczas procesu ładowania, skontaktuj się z gorącą linią obsługi posprzedażnej pod adresem 0755-89993588",
    "rechDiscount": "Zniżono już",
    "Search": "Szukaj",
    "warning": "Wczesne ostrzeżenie",
    "Recharge_tip2": "Proszę wybrać na przykład: ta sama nośność to 1; Ten sam typ karty to 4G; Ładowanie masowe dla kart danych Chin kontynentalnych w tym samym regionie",
    "Recharge_tip1": "Obsługuje tylko ładowanie masowe kart tego samego typu",
    "rechScan": "Proszę otworzyć mobilny WeChat i zeskanować, aby zakończyć płatność",
    "rechTip": "Przypomnienie: 1. Tylko urządzenia o tym samym typie karty (np. 4G krajowej), takiej samej nośności i tym samym statusie platformy łagodzenia ubóstwa mogą być wybrane dla tej samej kolejności (domyślny wyświetlacz pokazuje pakiety o pojemności 1 i nie podłączone do platformy łagodzenia ubóstwa); 2. Naładowanie zaległych kart i ładowanie pomiędzy 25-tym i piątym miesiąca spowoduje opóźnienie o 1-14 dni. Prosimy o cierpliwość i poczekanie",
    "Traffic_status": "Status ruchu",
    "Status": "Status karty drogowej",
    "DataloggerPN": "PN：",
    "Recharge_money": "Wartość powtórnego ładowania",
    "Overdue": "Już zaległe",
    "Cancel_recharge": "Anuluj ładowanie",
    "Datalogger_List": "Lista kolekcji",
    "Recharged": "Doładowanie zakończone pomyślnie",
    "Rcharge_Month": "Czas (miesiąc)",
    "Service_Area": "Obszar usługi",
    "Datalogger_PN": "Numer PN urządzenia do pozyskiwania danych",
    "rechargeDevice": "Urządzenie ładowania:",
    "rechargeSucInfo": "Pomyślnie dokonałeś płatności, a dane zostaną zaliczone na Twoje konto w ciągu 24-godzin",
    "Confirm_recharge": "Potwierdź ładowanie",
    "scan": "Skanuj i zapłać",
    "Paid": "Płatne",
    "Time": "Czas powtórnego ładowania",
    "Unpaid": "Bezpłatne",
    "Operation": "Operacja",
    "Connecting_Devices": "Z zaladowana liczba",
    "Recharge_reminder": "Przypomnienie o doładowaniu",
    "scanComplete": "Skanuj do zakończenia płatności",
    "unknown": "Nieznany",
    "rechargeChannel": "Metoda ładowania:",
    "Signal": "Wartość sygnału",
    "Plant": "Nazwa systemy PV",
    "area_domestic": "Chiński kontynent",
    "rechargeDiscount": "Kwota rabatu:",
    "expired": "Nieprawidłowe",
    "load": "Z zaladowana liczba",
    "Recharge_List": "Lista ładowania",
    "ccid": "Numer karty przepływowej urządzenia do pozyskiwania danych",
    "Order_Number": "Numer zamówienia",
    "Package_type": "Typ opakowania",
    "Recharge_record": "Rekord ladowania",
    "DataloggerName": "alias",
    "Recharging": "Doładowywanie",
    "Recharge_Selected": "Doładuj",
    "rechargeErr": "Proszę wybrać rejestrator danych o tej samej nośności",
    "rechargePrice": "Kwota naładowania:",
    "abroad": "za granicą",
    "normal": "Zwykły",
    "previous": "Powrót",
    "CCID": "Numer karty danych",
    "CCID_time": "Data ważności karty danych",
    "serial_number": "Numer seryjny",
    "Activation_Time": "Czas aktywacji",
    "confirm": "Ok",
    "Recharge_status": "Status ponownego ładowania",
    "Recharge_now": "Naładować teraz",
    "Content_warning": "Drogi użytkowniku, witaj! Zostało stwierdzone, że karta danych urządzenia niedługo wygasa. Brak terminowego naładowania może spowodować anulowanie karty danych przez operatora i niemożliwość kontynuowania korzystania z karty danych. Aby nie wpłynąć na normalne użytkowanie, należy w odpowiednim czasie naładować urządzenia w stanie ostrzegawczym!",
    "Recharge_fail": "Ładowanie nie powiodło się",
    "rechargePackage": "Pakiet ładowania:",
    "rechargeSuc": "Płatność pomyślna",
    "pn": "Numer PN urządzenia do pozyskiwania danych",
    "Tips": "Podpowiedzi",
    "Recharge_successful": "Doładowanie zakończone pomyślnie"
  },
  "settingalarm": {
    "Delete": "Usuń",
    "Add": "Dodaj",
    "cancel": "Anuluj",
    "Warning": "Alarm",
    "deletes": "Usuń",
    "Email": "Adres emial",
    "Add_suc": "Dodano pomyślnie e-mail push!",
    "suredelete": "Na pewno chcesz usunąć ten push e-mail?",
    "Yes": "Tak",
    "Fault": "Przypomnienie",
    "Operation": "Operacja",
    "E_Mail": "Email",
    "delete": "E-mail usunięty pomyślnie",
    "chosesstation": "Proszę wybrać elektrownię",
    "Receiving_Plant": "Zalecane elektrownie:",
    "Plant": "Stowarzyszona elektrownia",
    "Alarm_Type": "Typ alarmu:",
    "create": "ustanowić",
    "Monthly_Report": "Raport miesięczny",
    "Add_Mailbox": "Dodaj powiadomienia e-mail push",
    "No": "Nie",
    "Yearly_Report": "Raport roczny",
    "edit": "Edycja",
    "addEmails": "Dodaj adres e-mail",
    "Error": "Błąd",
    "list": "Numer seryjny",
    "Email_Setting": "Ustawienia push e-mail",
    "Email_List": "lista mailingowa",
    "Receiving_Report": "Zarządzanie raportami",
    "Alarm_Typetabel": "Typ alarmu",
    "Delete_Mailbox": "Usuń e-mail",
    "Daily_Report": "Raport dzienny"
  },
  "firmware": {
    "Firmware_limit_format": "Dozwolone są tylko formaty plików .bin, .hex i .s19",
    "Firmware_upload_fail": "Przesyłanie nieudane, spróbuj ponownie!",
    "Firmware_upload_failTip": "Przesyłanie nieudane",
    "Firmware_limit1": "Możesz przesłać maksymalnie",
    "Firmware_limit2": "pliki",
    "Firmware_limit3": "firmware",
    "Firmware_limitM": "Pojedynczy plik firmware nie może przekraczać",
    "cancel": "Anuluj",
    "Select_file": "Wybierz plik",
    "Upload1": "Prześlij plik",
    "Size": "Rozmiar oprogramowania (KB)",
    "Firmware_desrc": "Opis firmware",
    "upgrade_quit1": "Wyjątek ulepszenia, zakończony!",
    "deleteSuc": "Usuwanie zakonczone sukcesem",
    "Upload": "Ładowanie firmware",
    "del_firmware": "Usuń oprogramowanie firmware",
    "Upload_firmware": "Ładowanie firmware",
    "Operation": "Operacja",
    "downloadFirmware": "Pobierz",
    "tips": "Podpowiedzi",
    "deleteFirmware": "Usuń",
    "Firmware_Version": "Numer wersji",
    "Firmware_List": "Zarzadzanie Firmware",
    "limit1": "Tylko pliki w formacie 'xlsx' mogą być przesłane",
    "limit2": "Przypomnienie przyjazne: Kolumna A przesłanego pliku to PN kolekcjonera danych, a kolumna B to alias kolekcjonera danych. Nie jest wymagany tytuł, patrz na poniższy rysunek.",
    "limit0": "Można przesłać tylko pliki w formatach \". bin\", \".hex\" i \". s19\", a rozmiar pliku nie powinien przekraczać 8MB",
    "limit": "Mogą być przesłane tylko pliki w formatach \". bin\" i \". hex\" i nie powinny one przekraczać rozmiaru 8MB",
    "FailedCancelUpgrade": "Skasowanie aktualizacji zakonczone niepowodzeniem",
    "Firmware_Lists": "Lista oprogramowania sprzętowego",
    "uploadTips": "Proszę przesłać plik oprogramowania firmware",
    "limit3": "Dodanie zakonczone sukcesem",
    "Upload_Time": "Czas przesyłania",
    "Add_Firmware": "Dodaj oprogramowanie firmware",
    "upgrading1": "Aktualizuję połączenie, proszę poczekać",
    "Firmware_Name": "Nazwa oprogramowania firmware",
    "upgrading": "Aktualizacja w toku",
    "editFirmware": "Edycja",
    "Firmware_description": "Opis oprogramowania:",
    "confirm": "Ok",
    "upgrade_quit8": "Wyjątek aktualizacji",
    "upgrade_quit7": "Aktualizacja nie powiodłą sie",
    "noRecord": "Brak danych",
    "upgrade_quit6": "Anuluj aktualizację",
    "UploadTitle": "Proszę przesłać pliki wsadowe",
    "enter_content": "Proszę wprowadzić treść",
    "upgrade_quit5": "Nie podlega aktualizacji",
    "upgrade_quit4": "Aktualizacja została manualnie zatrzymana",
    "upgrade_quit3": "Aktualizacja zakończona sukcesem",
    "delete_firmware": "Na pewno chcesz usunąć ten oprogramowanie?",
    "upgrade_quit2": "Aktualizacja nie powiodła się, spróbuj ponownie później!",
    "updateCompleted": "Zakończona modernizacja",
    "firmware_upgrade": "Aktualizacja oprogramowania firmware",
    "CancelUpgradeSuc": "Skasowanie aktualizacji zakonczone sukcesem",
    "error1": "Tylko pliki w formatach \". bin\", \". hex\" i \". s19\" mogą być przesłane",
        "error2": " Please press LFU button",
    "CancelUpgradeSuc11": "Pomyślnie anuluj aktualizację, poczekaj, aż kolektor podłączy się do chmury",
    "upgrade_wait": "Trwa przygotowywanie aktualizacji, proszę poczekać 1–2 minuty",
    "upgrade_wait1": "Przygotowanie aktualizacji zakończone. Poczekaj, aż zbieracz danych będzie online, a następnie ponownie uruchom zadanie aktualizacji",
    "colOffline": "Datalogger jest offline",
		"colUpgrading": "Już trwa aktualizacja",
    "UpgradeStarting": "Aktualizacja startuje, proszę poczekać...",
    "upgradeSq_fail": "Aktualizacja datalogger nie powiodła się, spróbuj ponownie później!",
    "batch_edit_datalogger": "Edytuj datalogger partiami",
    "upload_column_tips": "Przypomnienie: Kolumna A to PN dataloggera, Kolumna B to liczba obciążeń, Kolumna C to prędkość transmisji, Kolumna D to protokół komunikacji, Kolumna E to kod producenta urządzenia, Kolumna F to kod producenta protokołu, Kolumna G to tryb zbierania, Kolumna H to min adres komunikacji, Kolumna I to max adres komunikacji, bez tytułu, patrz poniższy obraz",
    "upload_csv_tips": "Przypomnienie: Format pliku musi być csv, patrz poniższy obraz",
    "click_enlarge": "Kliknij, aby powiększyć szczegóły",
        "collector_expire_time": "Czas wygaśnięcia kolektora",
        "collection_cycle": "Cykl zbierania",
            "ascii_display": "Wyświetlanie ASCII:"
  },
  "customize": {
    "orange": "Słodka pomarańcza",
    "green": "Świeża zielona",
    "classic": "różowy",
    "blue": "Klasyczny niebieski",
    "purple": "fioletowy;",
    "switchSkin": "Przełączanie skóry"
  },
  "browse": {
    "pleaseUsr": "Proszę wpisać podkonto",
    "deleteBrowse": "Usuń",
    "pleaseDevice": "Wybierz projekt",
    "editBrowse": "Edytuj podkonto",
    "addSuccess": "Pomyślnie dodane podkonto",
    "password": "Hasło",
    "usr": "Podrachunek",
    "pleaseDevice_title": "Proszę wybrać projekt",
    "deleteSuccess": "Usuwanie zakonczone sukcesem",
    "confirmPassword": "Potwierdź hasło",
    "Enable": "Włącz",
    "Disable": "Wyłącz",
    "email": "Adres emial",
    "accountInfo": "Informacje o koncie",
    "delete_browse": "Na pewno usuniesz podkonto?",
    "addBrowse": "Dodaj podkonto",
    "gts": "Data rejestracji",
    "mobile": "Telefon komórkowy",
    "newPassword": "Nowe hasło",
    "editSuccess": "Pomyślnie edytowane podkonto",
    "please_browsepwd": "Sprawdź nowe hasło i potwierdź wymagania wprowadzania hasła",
    "pleaseStatus": "Wybierz status",
    "device": "Wybór projektu",
    "usrInfo": "Informacje o użytkowniku",
    "enableStatus": "Włącz status",
    "username": "Nazwa użytkownika",
    "desc": "Uwagi"
  },
  "controlDeviceErrCode": {
    "11": "Brak zgody, proszę skontaktować się z administratorem",
    "1": "Operacja nie powiodła się, sprawdź urządzenie i spróbuj ponownie!",
    "2": "Przerwa odpowiedzi, spróbuj ponownie!",
    "3": "Wyjątek systemowy, prosimy o kontakt z administratorem",
    "6": "Błąd formatowania, proszę skontaktować się z administratorem",
    "8": "Odrzuć, proszę skontaktować się z administratorem",
    "9": "Operacja nie jest obsługiwana, prosimy o kontakt z administratorem",
    "263": "Aktualny rejestrator danych jest offline. Proszę spróbować ponownie, gdy urządzenie jest online!"
  },
  "control":{
		"setting": "Wydanie",
    "TouSetting": "Tryb Pracy Systemu",
    "touCharge": "Priorytet Ładowania",
    "touPersonal": "Samodzielnego Użytkowania",
    "touComplete": "Pełne Zasilanie Sieci",
    "touClipping": "Obcinanie Szczytów i Wypełnianie Dolin",
    "touOffgrid": "Aplikacja Poza Siecią",
    "confirmModeSwitch": "Potwierdzić Zmianę Trybu?",
    "modeSwitch": "Zmień Tryb",
    "startTime": "Godzina Rozpoczęcia",
    "endTime": "Godzina Zakończenia",
    "paramValue": "Wybierz Wartość Parametru",
    "Monday": "Poniedziałek",
    "Tuesday": "Wtorek",
    "Wednesday": "Środa",
    "Thursday": "Czwartek",
    "Friday": "Piątek",
    "Saturday": "Sobota",
    "Sunday": "Niedziela",
    "syncSetDay": "Synchroniczne Wydanie Dziennie",
    "time": "Okres Czasowy 1",
    "time1": "Okres Czasowy 2",
    "time2": "Okres Czasowy 3",
    "time3": "Okres Czasowy 4",
    "time4": "Okres Czasowy 5",
    "time5": "Okres Czasowy 6",
    "setFail": "Wydanie Nie Powiodło Się",
    "readFail": "Odczyt Nie Powiódł Się",
    "charge": "Ładowanie",
    "discharge": "Rozładowanie",
    "reading": "Odczytano Pomyślnie",
    "reading_loading": "Trwa Odczyt...",
    "pvMode": "Tryb Zasilania Sieci",
    "screenshot": "Zrzut Ekranu"
	},
  "CollectorCountByOMSOrder": {
    "23": "Kod producenta jest nieprawidłowy. Proszę skontaktować się z administratorem",
    "12": "Pod zamówieniem nie ma ważnego numeru PN kolekcjonera. Proszę potwierdzić numer zamówienia",
    "1": "operacja nie powiodła się",
    "772": "To zamówienie jest już powiązane z kolekcjonerem. Proszę potwierdzić, że kolekcjoner w zamówieniu nie jest związany z kolekcjonerem.",
    "259": "W ramach tego zamówienia istnieje nieprawidłowy kolekcjoner, skontaktuj się z administratorem",
    "7": "Brak niezbednych parametrów",
    "8": "Odrzuć, proszę skontaktować się z administratorem",
    "261": "Nie można znaleźć przypisanego dealera, skontaktuj się z administratorem"
  },
  "errCode": {
    "271": "Brak operacji modyfikacji",
    "272": "Powtórz powiązanie",
    "273": "Dodawanie urządzeń monitorujących innych producentów nie jest obsługiwane",
    "352": "Brak oprogramowania firmware",
    "353": "Nie znaleziono oprogramowania firmware",
    "276": "Aplikacje mobilne innych producentów nie są obsługwane",
    "512": "Błedny kod weryfikacyjny SMS",
    "513": "Minął czas na podanie kodu weryfikacyjnego SMS",
    "514": "Numer telefonu/e-mail niezwiązany",
    "515": "Niedopasowanie numeru telefonu/e-maila",
    "516": "Nazwa / Imię nie może się powtarzać?",
    "517": "Użytkownik lub instalacja posiadają już urządzenia monitorujące",
    "518": "Użytkownik ma również podległych użytkowników",
    "519": "Powtórz nazwę użytkownika",
    "10": "Nie udało się uwierzytelnić, zaloguj się ponownie",
    "11": "Nieautoryzowana operacja",
    "12": "Brak danych",
    "13": "Przekroczono limit",
    "14": "Powtórzone operacje",
    "15": "Nie znaleziono klucza producenta",
    "16": "Błędne hasło",
    "17": "Błędny format hasła",
    "18": "Ten numer telefonu jest już używany",
    "1792": "Urządzenie monitorujące musi należeć do administratora",
    "19": "Błędny format numeru telefonu",
    "1031": "Użytkownik nie został utworzony przez tego administratora",
    "1030": "Nieprawidłowa karta GPRS",
    "0": "Brak bledow",
    "1029": "Powtorzona liczba cyfrowych danych",
    "1": "Niepowodzenie",
    "1028": "Nieobsługiwana metoda ładowania",
    "288": "Brak kamery",
    "2": "Przekroczono limit czasu",
    "1027": "Użytkownik z najwyższymi uprawnieniami musi być administratorem lub producentem sprzętu",
    "520": "Podwójny numer PN",
    "3": "Wyjątek systemowy, prosimy o kontakt z administratorem",
    "1026": "Obsługa tylko dla producentów sprzętu",
    "521": "Urządzenie monitorujące nie należy do tego użytkownika",
    "4": "Nie uzywaj znakow specjalnych",
    "1025": "Obsługa tylko dla administratorów",
    "522": "Urządzenie monitorujące już istnieje",
    "368": "Brak roli użytkownika",
    "5": "Nie zweryfikowany podpis",
    "1024": "Obsługa tylko dla właścicieli systemów PV",
    "523": "Dozwolone tylko dla wlasciciela instalacji PV",
    "369": "Brak grupowania użytkowników",
    "6": "Nieprawidlowy format parametru",
    "7": "Brak niezbednych parametrów",
    "525": "Kod weryfikacyjny został wysłany, spróbuj ponownie później",
    "528": "Rola ta jest już powiązana z użytkownikiem i nie może zostać usunięta",
    "8": "Niedozwolona operacja",
    "768": "Brak opcjonalnych pól w protokole",
    "9": "Brak wymaganych parametrow",
    "20": "Błąd formatu e-mail (6<=długość e-mail<64, w tym symbol)",
    "21": "Błędny format nazwy użytkownika",
    "22": "Błedny format nazwy firmy",
    "23": "Nieprawidłowy kod producenta",
    "24": "Powtórz nazwę użytkownika",
    "25": "Konto zostało wyłączone, skontaktuj się z administratorem",
    "26": "Email jest już związany, proszę zmienić e-mail lub odwiązać",
    "27": "Konto zostało anulowane, prosimy o kontakt z administratorem",
    "1042": "Nieprawidłowy CCID",
    "1041": "Klucz wygasł lub nie można go znaleźć",
    "370": "Brak grupowania systemów PV",
    "371": "Brak pakietu transmisji danych GPRS",
    "372": "Brak poloczenia GPRS",
    "772": "Kolekcjoner został związany",
    "256": "Brak danych",
    "257": "Nie można znaleźć liczby urządzeń monitorujących",
    "258": "Brak sprzętu",
    "259": "Nieprawidłowy numer PN, sprawdź czy numer PN jest poprawny",
    "260": "Nie znaleziono instalacji PV",
    "261": "Nie można znaleźć użytkownika",
    "262": "Mikroinwerter jest wyłączony",
    "384": "Nieprawidłowy kod weryfikacyjny",
    "263": "Urządzenie monitorujące jest wyłączone",
    "385": "Brak tokenu urządzenia",
    "264": "Brak alarmu urządzenia",
    "386": "Brak informacji o konfiguracji urządzenia",
    "265": "Brak detektora środowiskowego",
    "387": "Nieznany typ urządzenia monitorującego"
  },
  "report": {
    "cancel": "Anuluj",
    "select_date": "Proszę wybrać datę",
    "Yearly_Report": "Raport roczny",
    "Export_report": "Eksportowanie raportu",
    "Export_alarm": "Eksportuj alarmy",
    "Report_date": "Data raportu:",
    "no_deAlarm": "W ciągu ostatniego miesiąca nie wystąpiły żadne alarmy urządzenia",
    "Report_date1": "Uwaga: Zakres eksportowanych dat nie może przekraczać 31 dni",
    "Total_report": "Raport całkowity",
    "Subscribe_report": "Sprawozdanie z subskrypcji",
    "customize": "Niestandardowe",
    "all_reports": "Eksportuj wszystkie",
    "current": "w tej chwili",
    "download": "Pobieranie w toku, proszę poczekać",
    "Report_type": "Typ raportu:",
    "Export": "Eksportuj",
    "Daily_report": "Raport dzienny",
    "to": "Całkowita wartość pojemności ",
    "Batch_export": "Eksport partii",
    "Monthly_report": "Raport miesięczny",
    "End_date": "Data końcowa",
    "start_date": "Data rozpoczęcia"
  },
  "retrieve": {
    "Verification_code": "Kod weryfikacji",
    "passwordPhone": "Niezwiązany numer telefonu komórkowego",
    "Email": "Adres emial",
    "enter_code": "Wprowadź kod weryfikacyjny",
    "re-register": "Zaloguj się ponownie",
    "login": "Zaloguj się",
    "Reset_successfully": "Resetowanie hasła pomyślnie, proszę zapamiętać nowe hasło",
    "Retrieve_passwordEmail": "Pobieranie hasła e-mail",
    "bound_mobile": "Proszę wprowadzić powiązany numer telefonu",
    "Retrieve_password": "Pobierz hasło",
    "passwordPhone1": "Niedopasowanie numeru telefonu",
    "Confirmloginpassword": "Potwierdź nowe hasło logowania",
    "Get_codeSucc": "Pomyślnie uzyskany kod weryfikacyjny",
    "New_password": "Nowe hasło logowania",
    "email_first": "Proszę najpierw wypełnić swój e-mail",
    "code_1minute": "Kod weryfikacyjny został wysłany na Twój telefon i będzie ważny w ciągu jednej minuty",
    "finish": "kompletny",
    "Retrieve_passwordPhone": "Pobierz hasło w telefonie komórkowym",
    "bound_email": "Proszę wprowadzić powiązany adres e-mail",
    "Email_verification": "Weryfikacja e-maila",
    "step4": "Krok czwarty",
    "code_5minutes": "Kod weryfikacyjny został wysłany na Twój e-mail i będzie ważny w ciągu pięciu minut",
    "Getting_progress": "Zbieram, proszę poczekać!",
    "Confirm_password": "Potwierdź nowe hasło",
    "reset_Password": "Reset hasła",
    "enter_name": "Wprowadź jednego użytkownika",
    "mobile_first": "Proszę najpierw wypełnić swój numer telefonu",
    "Phone_verification": "Weryfikacja mobilna",
    "Reset_passwordSuc": "Resetowanie hasła pomyślne",
    "step2": "Krok 2",
    "step3": "Krok trzeci",
    "signup": "zarejestruj się",
    "step1": "Krok pierwszy",
    "confirm": "Potwierdź",
    "account_password": "Proszę wpisać konto, do którego potrzebne jest odzyskanie hasła",
    "Change_one": "Zmień jeden",
    "Obtain_code": "Uzyskaj kod weryfikacyjny",
    "Incorrect_code": "Kod weryfikacyjny jest nieprawidłowy",
    "new_password": "Nowe hasło logowania",
    "passwordEmail1": "Niedopasowanie e-maila",
    "passwordEmail": "Niezwiązana wiadomość e-mail",
    "Newloginpassword": "Nowe hasło logowania",
    "phone_number": "Numer telefonu komórkowego",
    "Verify_identidy": "Sprawdź tożsamość",
    "Enter_account": "Wpisz konto",
    "Con_password": "Potwierdź nowe hasło",
    "username": "Nazwa użytkownika"
  },
  "message": {
    "cancel": "Anuluj",
    "pwd_is_required": "Hasło nie może być puste",
    "id_is_required": "Grupowanie nie może być puste",
    "email_info": "Poprawny adres e-mail w 64-znakach",
    "delete_plant": "Usuń system PV",
    "Exporting_the_report": "Eksportowanie raportu",
    "length6_20": "Można wprowadzać tylko 6-20 liter, cyfr i podkreślenia",
    "length6_32": "Długość od 6 do 32 znaków",
    "nodata": "Brak danych",
    "oldPass_wrong": "Stare hasło nieprawidłowe, proszę ponownie wprowadzić",
    "invitation_is_required": "Kod doświadczenia nie może być pusty",
    "length2_32": "Długość od 2 do 32 znaków",
    "pwdSame": "Nowe i stare hasła nie mogą być takie same",
    "pn_is_required": "PN nie może być pusty",
    "pwdAgain": "Proszę wprowadzić hasło ponownie",
    "search": "Szukaj",
    "pwdNotsame": "Hasło wprowadzone dwa razy jest niespójne",
    "length2_64": "Długość od 2 do 64 znaków",
    "uname_is_required": "Konto nie może być puste",
    "Logging_off": "Konto jest aktualnie anulowane i nie można się zalogować",
    "modify_plant": "Modyfikuj system PV",
    "PN_info": "Numer PN ma długość 14 lub 18-cyfr, przy czym pierwsza cyfr jest wielką literą, zawierającą tylko duże litery angielskie i liczby",
    "confpwd_is_required": "Potwierdzenie hasła nie może być puste",
    "mobile_is_required": "Numer telefonu nie może być pusty",
    "email_is_required": "E-mail nie może być pusty",
    "country_is_required": "Proszę wybrać kraj lub region",
  },
  "factory": {
    "factoryInfo": "Informacje o producencie",
    "code": "Kod fabryczny",
    "right_tip": "Wpisz poprawnie",
    "ecoin": "Moneta e",
    "prompt_codeTip": "Kod producenta nie może być pusty",
    "error_tip": "Błąd wpisanych danych",
    "delete": "Usuń kod producenta",
    "enabled": "Włączone",
    "acountType": "Typ rachunku",
    "devcode_is_requeired": "Kod urządzenia nie może być pusty",
    "disabled": "niewłączone",
    "ID": "Identyfikator producenta",
    "usrName": "Nazwa konta",
    "accountInfo": "Informacje o koncie",
    "editSuc": "Modyfikacja zakończona",
    "confirmDelete1": "Producent?",
    "acount": "Rachunek producenta",
    "visibleDevcode": "Widoczny kod urządzenia",
    "input_tip": "Kod producenta składa się z 2-3 cyfr lub liter",
    "amend": "Zmień kod producenta",
    "comfirmPwd": "Potwierdź hasło",
    "prompt_nameTip": "Nazwa producenta nie może być pusta",
    "confirmDelete": "Potwierdź usunięcie",
    "devcode": "Kod urządzenia",
    "isEnabled": "Czy to włączone",
    "chooseIsEnabled": "Proszę wybrać, czy włączyć czy nie",
    "name": "Nazwa producenta",
    "delete_warn": "Potwierdziłeś usunięcie kodu producenta?",
    "time": "Czas generowania",
    "pwd": "Hasło",
    "append": "Dodaj kod producenta"
  },
  "protocol": {
    "CRC_verification": "Weryfikacja CRC",
    "date": "Data",
    "postal_address": "Adres do korespondencji",
    "Protocol_encoding": "Kodowanie protokołu",
    "agreement": "porozumienie",
    "query": "zapytanie",
    "Length_verification": "Weryfikacja długości",
    "Please_results": "Proszę najpierw uzyskać wyniki zapytania",
    "Protocol_instructions": "Instrukcja protokołu",
    "verification_results": "Wynik weryfikacji CRC",
    "Data_index": "Indeks danych",
    "atypism": "atypizm",
    "Please_date": "Proszę wybrać datę",
    "verification_result": "Wynik weryfikacji długości",
    "raw_data": "dane surowe",
    "pn": "Numer cześci",
    "Analysis_results": "Wyniki analizy",
    "Query_Results": "Wyniki zapytania"
  },
  "rawData": {
    "date": "Data",
    "no": "Nie",
    "Please_type": "Proszę wybrać typ szyfrowania",
    "Device_address": "Adres urzadzenia",
    "encrypted": "Czy to zaszyfrowane",
    "yes": "Tak",
    "Please_date": "Proszę wybrać datę",
    "Equipment_coding": "Kod urządzenia",
    "Equipment_number": "Numer seryjny urządzenia",
    "analysis": "analiza",
    "raw_data": "dane surowe",
    "pn": "Numer cześci"
  },
  "keyList": {
    "companyNameTips": "Nazwa firmy nie może być pusta",
    "keyTips2": "Klucz o długości szesnastu bajtów",
    "companyName": "Pełna nazwa firmy",
    "contact_information": "dane kontaktowe",
    "version_number": "Numer wersji",
    "version_numberTips": "Numer wersji nie może być pusty",
    "platform": "platforma",
    "contact_informationTips": "Informacje kontaktowe nie mogą być puste",
    "keyTips": "Klucz nie może być pusty",
    "domainNameTips": "Pełna nazwa domeny nie może być pusta",
    "clientTips": "Platforma nie może być pusta",
    "domainName": "Pełna nazwa domeny",
    "describeTips": "Opis nie może być pusty",
    "client": "klient",
    "unsealTips": "Czy włączenie nie może być puste",
    "describe": "opis",
    "unseal": "Czy to włączone",
    "key": "key"
  },
  "actionLog": {
    "All": "Wszystkie",
    "date": "Data",
    "PNNote": "Prosze wprowadź numer seryjny",
    "actionNote": "Proszę wprowadzić akcję interfejsu",
    "userNote": "Wprowadź jednego użytkownika",
    "index": "Numer seryjny",
    "startTime": "Czas rozpoczęcia",
    "endTime": "Czas zakończenia",
    "userName": "Nazwa użytkownika",
    "acitonDesc": "Opis operacji",
    "user": "Użytkownik",
    "uidNote": "Proszę wprowadzić UID"
  },
  "collectionFrequencyUP": {
    "collect_fast": "Przyspieszenie zbierania danych o przepływie energii",
    "collect_fast2": "Przyspieszenie przepływu energii",
    "collect_fast_fail": "Przyspieszenie nie powiodło się, spróbuj ponownie",
    "collect_fasting": "Przyspieszenie",
    "collect_fast_starting": "Uruchamianie przyspieszenia",
    "collect_fast1": "Przyspieszenie zbierania szczegółowych danych",
    "collect_fast1ing": "Przyspieszenie danych",
    "paySecCon": "Potwierdzenie płatności",
    "energyFetchPic": "Czy potwierdzić ładowanie, zakres przyspieszenia ładowania dla parametrów strony mapy przepływu energii jak na poniższym rysunku",
		"historyFetchPic": "Czy potwierdzić uzupełnienie, zakres przyspieszenia uzupełnienia jest dane szczegółowe parametry strony jak na poniższym rysunku",
		"reRechargeTip1": "Bieżące urządzenie zakupiło już usługę przyspieszenia przepływu energii. Kontynuowanie zakupu spowoduje ponowne naliczenie opłat. Czy chcesz kontynuować?",
		"reRechargeTip": "Bieżące urządzenie zakupiło już usługę przyspieszenia szczegółów danych. Kontynuowanie zakupu spowoduje ponowne naliczenie opłat. Czy chcesz kontynuować?",
		"continueRecharge": "Kontynuuj doładowanie",
    "collect_fasting_title": "Parametry czasu rzeczywistego nie są zapisywane",
    "collect_Order_Record": "Przyspieszenie rejestru",
    "Collection_terms": "Warunki przyspieszenia ładowania częstotliwości zbierania",
    "Recharge_failed_next": "Przepraszamy za nieudane ładowanie, możesz spróbować ponownie płacić",
    "view_order": "Wyświetl zamówienia",
    "Once": "drugie",
    "every_interval": "Aktualnie wybrana specyfikacja przyspieszenia to: każdy interwał",
    "Collect_terms2": "1,Zakres stosowania opakowania",
    "Collect_terms3": "Parametry wyświetlania zawarte w protokole używanym przez kolektor do ładowania (uwaga: jeśli wybierzesz stronę Wykres przepływu energii dla przyspieszonego ładowania, zakres opakowania jest ograniczony do zakresu parametrów wyświetlania strony Wykres przepływu energii; jeśli wybierzesz stronę Dane historyczne dla przyspieszonego ładowania, zakres opakowania jest ograniczony do zakresu parametrów wyświetlania strony Dane historyczne)",
    "Collect_terms4": "2,Nie obsługuje protokołu/wymiany urządzeń",
    "have_read": "Przeczytałem ją dokładnie.",
    "Collect_terms5": "Zmiana protokołów/urządzeń nie uczestniczy w przyjemności przyspieszenia",
    "Collect_terms6": "3,Usuń subskrypcję pakietu",
    "Collect_terms": "Pobieranie terminów przyspieszonego ładowania",
    "View_Details": "Zobacz szczegóły",
    "Recharge_result": "Wynik ładowania",
    "Collect_terms7": "Wypisz subskrypcję i zmiana nie jest obsługiwana po dokonaniu płatności",
    "Online_payment": "Płatności online",
    "Collect_terms8": "4,5Cena pakietu",
    "Collect_terms9": "Nasze opłaty są obliczane na podstawie ilości parametrów, przyspieszonej częstotliwości pobierania i nośności, a ostateczna cena jest odpowiednio ustalana; Oprócz powyższych warunków dane historyczne obejmują również czas przechowywania",
    "acquisition_frequency": "Częstotliwość zbierania",
    "Recharge_failed": "Ładowanie nie powiodło się",
    "Recharge_amount": "Wartość powtórnego ładowania",
    "Scan_payment": "Płatność za kod skanowania",
    "collect_recharge": "Przyspieszenie ładowania zbierania (przyspieszenie zbierania szczegółowych danych)",
    "collect_recharge1": "Przyspieszenie ładowania zbierania (przyspieszenie przepływu energii)",
    "Collect_terms10": "5,5,Konsumpcja ruchu drogowego",
    "Purchase_Terms7": "Są inne pytania.",
    "Purchase_Terms8": "Jeśli masz jakieś inne pytania, możesz skontaktować się z naszym działem obsługi klienta online w celu uzyskania konsultacji, a my udzielimy szczegółowych odpowiedzi",
    "Collect_terms11": "Przyspieszenie częstotliwości zbierania zwiększy zużycie ruchu",
    "Purchase_Terms6": "Nasze opłaty są obliczane na podstawie ilości parametrów, przyspieszonej częstotliwości pobierania i nośności, a ostateczna cena jest odpowiednio ustalana; Oprócz powyższych warunków dane historyczne obejmują również czas przechowywania",
    "Purchase_Terms5": "Cena pakietu",
    "Purchase_Terms4": "Czekamy na naszą nową wersję. Aktualna wersja obsługuje jedynie zbieranie i aktualizację wszystkich parametrów wyświetlania. Przepraszamy za wszelkie niedogodności spowodowane!",
    "Purchase_Terms3": "Nie mogę dostosować aktualizacji częstotliwości kolekcji dla niektórych parametrów",
    "Real_parameters": "Parametry czasu rzeczywistego",
		"Purchase_Terms1": "Okres ważności przyspieszenia zbierania danych",
		"Purchase_Terms2": "Czas wygaśnięcia usługi przyspieszenia zbierania danych zostanie automatycznie obliczony na podstawie czasu trwania zakupionego pakietu. Dokładny czas wygaśnięcia jest zgodny z informacjami wyświetlanymi na stronie",
    "device_Info": "Informacje o wyposażeniu",
    "Recharge_successful_next": "Gratulacje udanego ładowania. Właśnie zmienimy częstotliwość zbierania, a od teraz możesz śledzić zmiany częstotliwości zbierania.",
    "Purchase_Terms": "Warunki zakupu",
    "gather": "kolekcja",
    "Recharge_time": "Czas powtórnego ładowania",
    "Payment_method": "Warunki płatności",
    "Type": "Rodzaj uzupełnienia",
    "Recharge_now": "Naładować teraz",
    "History_Data": "dane historyczne",
    "Collect_terms1": "Warunki usługi przyspieszania częstotliwości zbierania",
    "Package": "Pakiet przyspieszenia",
    "PN_order": "PN/numer zamówienia",
    "Order_No": "Numer zamówienia",
    "Recharge_successful": "Doładowanie zakończone pomyślnie",
    "noRecharg": "Kolektor nie obsługuje ładowania",
    "noRecharg_min": "Twoja prędkość zbierania osiągnęła najszybszą!",
    "noRecharg_wifi": "Aktualna wersja obsługuje tylko pozyskiwanie danych modułu Wi-Fi",
    "paypalTip": "Ostateczna kwota płatności jest oparta na PayPal",
    "upPrice": "Różnica cenowa",
  },
  alarmNew: {
    'fileName': 'Nazwa pliku',
    'fileSize': 'Rozmiar pliku',
    'fileStatus': 'Status pliku',
    'progress': 'Postęp',
    'can': 'Możliwość pobrania',
    'no': 'Eksportowanie',
    'history': 'Historia eksportu'
  },
  	shuoriExport:{
    "exportRecords": "Eksportuj dzienniki",
    "export": "Eksportuj",
    "exportTask": "Zadanie eksportu zostało utworzone. Pobierz plik później w sekcji „Eksportuj dzienniki”.",
    "noDownload": "Adres pliku jest nieprawidłowy lub nie można go pobrać. Spróbuj ponownie.",
    'data': 'Data',
	},
  	colUnBindRecord: {
    'UnBindRecord': 'Rejestr odwiązania zbieracza danych',
    "unStatus": "Status odwiązania",
    "unScene": "Scenariusz odwiązania",
    "oldUser": "Pierwotny użytkownik",
    "newUser": "Nowy użytkownik",
    "unCount": "Liczba odwiązań",
    "pnBarCode": "Kod kreskowy numeru części (PN)",
    "devicePicture": "Zdjęcie rzeczywistego urządzenia",
    "ip": "Odwiązany adres IP",
    "unTime": "Czas odwiązania"
	},
  	rosRecharge: {
		'electronicInvoicing': 'Fakturowanie elektroniczne',
		'issueEInvoice': 'Wystaw e-fakturę',
		'invoiceHistory': 'Historia faktur',
		'rechargeDuration': 'Czas doładowania',
		'year': 'Rok',
		'month': 'Miesiąc',
		'day': 'Dzień',
		'days': 'Dni',
		'pendingPayment': 'Oczekuje na płatność',
		'paymentSuccess': 'Płatność zakończona sukcesem',
		'paymentFailed': 'Płatność nieudana',
		'orderClosed': 'Zamówienie zamknięte',
		'serviceTerminated': 'Usługa zakończona',
		'unpaid': 'Nieopłacone',
		'paying': 'W trakcie płatności',
		'paid': 'Opłacone',
		'refunded': 'Zwrócone',
		'cancelled': 'Anulowane',
		'rechargeSuccess': 'Doładowanie zakończone sukcesem',
		'rechargeFailed': 'Doładowanie nieudane',
		'pleaseSelectDate': 'Proszę wybrać datę',
		'orderNo': 'Numer zamówienia',
		'batchInvoicing': 'Fakturowanie zbiorcze',
		'rechargeType': 'Typ doładowania',
		'trafficRecharge': 'Doładowanie transmisji danych',
		'collectRecharge': 'Doładowanie zbierania danych',
		'rechargeStatus': 'Status doładowania',
		'invoice': 'Faktura',
		'invoiceStatus': 'Status faktury',
		'invoiceTime': 'Czas wystawienia faktury',
		'viewDetail': 'Zobacz szczegóły',
		'invoicing': 'Fakturowanie w toku',
		'invoiceSuccess': 'Faktura wystawiona',
		'invoiceFailed': 'Wystawienie faktury nieudane',
		'issueElectronicInvoice': 'Wystaw e-fakturę',
		'invoiceType': 'Typ faktury',
		'generalInvoice': 'Faktura ogólna',
		'specialInvoice': 'Faktura VAT specjalna',
		'headerType': 'Typ nagłówka',
		'companyHeader': 'Nagłówek firmy',
		'personalHeader': 'Nagłówek osobisty/niefirmowy',
		'pleaseInputCompanyHeader': 'Proszę wprowadzić nagłówek firmy',
		'taxNumber': 'Numer podatkowy',
		'pleaseInputTaxNumber': 'Proszę wprowadzić numer identyfikacji podatkowej',
		'headerName': 'Nazwa nagłówka',
		'suggestPersonalName': 'Zalecamy podanie imienia i nazwiska/nazwy sklepu',
		'invoiceContent': 'Treść faktury',
		'internetCommService': 'Usługa komunikacji internetowej',
		'invoiceAmount': 'Kwota faktury',
		'yuan': 'CNY',
		'moreInfo': 'Więcej informacji',
		'remarkAddressEtc': 'Uwagi, adres itp.',
		'companyAddress': 'Adres firmy',
		'pleaseInputCompanyAddress': 'Proszę wprowadzić adres firmy',
		'companyPhone': 'Telefon firmy',
		'pleaseInputCompanyPhone': 'Proszę wprowadzić telefon firmy',
		'openingBank': 'Bank prowadzący rachunek',
		'pleaseInputOpeningBank': 'Proszę wprowadzić nazwę banku',
		'bankAccount': 'Numer konta bankowego',
		'pleaseInputBankAccount': 'Proszę wprowadzić numer konta bankowego',
		'remark': 'Uwagi',
		'pleaseInputRemark': 'Proszę wprowadzić uwagi',
		'email': 'E-mail',
		'pleaseInputEmail': 'Proszę wprowadzić adres e-mail',
		'cancel': 'Anuluj',
		'submit': 'Prześlij',
		'invoiceResult': 'Wynik fakturowania',
		'invoiceSubmitted': 'Wniosek o fakturę został przesłany',
		'invoiceExpectedTip': 'Faktura zostanie wystawiona w ciągu 48 godzin, proszę sprawdzić',
		'viewInvoiceStatus': 'Sprawdź status faktury',
		'pleaseInputHeaderName': 'Proszę wprowadzić nazwę nagłówka',
		'pleaseInputValidEmail': 'Proszę wprowadzić prawidłowy adres e-mail',
		'invoiceApplyFailed': 'Wniosek o fakturę nieudany',
		'viewInvoice': 'Zobacz fakturę',
		'downloadPdf': 'Pobierz PDF',
		'manualService': 'Obsługa ręczna',
		'invoiceSentToEmail': 'Informacje o fakturze zostały wysłane na Twój e-mail, proszę sprawdzić',
		'pleaseWaitInvoicing': 'Proszę cierpliwie czekać na zakończenie fakturowania',
		'pleaseContactManual': 'Proszę skontaktować się z obsługą ręczną w celu wystawienia faktury',
		'noPdfAvailable': 'Brak pliku PDF dostępnego do pobrania',
		'serviceUnavailable': 'Obsługa klienta jest obecnie niedostępna',

	}
}
export default cn;